/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'ขนาดใหญ่',
	['预设']: 'ค่าเริ่มต้น',
	['较小']: 'ขนาดเล็ก',
	['字级大小']: 'ขนาดตัวอักษร',
	['页面正在加载中']: 'กำลังโหลดหน้าเว็บ',
	['这可能需要几分钟的时间，请耐心等待']: 'อาจใช้เวลาสักครู่ กรุณารอ',
	['您所访问的页面不存在']: 'ไม่พบหน้าที่คุณต้องการเข้าถึง',
	['开始对话']: 'เริ่มการสนทนา',
	['充值未到帐快速通道']: 'ช่องทางด่วนแจ้งปัญหาเติมเงินไม่เข้า',
	['人工客服']: 'แชตสด',
	['已接听']: 'รับสายแล้ว',
	['结束对话']: 'จบการสนทนา',
	['联络人工客服']: 'ติดต่อเจ้าหน้าที่',
	['重新选择智能客服']: 'เลือกผู้ช่วยอัจฉริยะใหม่อีกครั้ง',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'ขอบคุณที่ใช้บริการค่ะ รบกวนสละเวลาสักครู่เพื่อทำแบบสอบถาม ความคิดเห็นของท่านเป็นแรงผลักดันสำคัญให้เราพัฒนาบริการให้ดียิ่งขึ้น',
	['您觉得此次的服务品质如何？']: 'คุณพึงพอใจกับการบริการในครั้งนี้อย่างไร',
	['颗星']: 'ดาว',
	['颗星(單數)']: 'ดาว',
	['不评分']: 'ไม่มีการให้คะแนน',
	['点选下方即可结束对话']: 'กดปุ่มด้านล่างเพื่อจบการสนทนา',
	['请输入您的ID']: 'กรุณากรอก ID',
	['ID不能为空']: 'จำเป็นต้องระบุ User ID',
	['说明文字']: 'คำอธิบาย',
	['送出']: 'ส่ง',
	['系统维护中']: 'ระบบปิดปรับปรุง',
	['储存']: 'บันทึก',
	['确认']: 'ยืนยัน',
	['取消']: 'ยกเลิก',
	['完成']: 'เสร็จ',
	['协作']: 'ความร่วมมือ',
	['转接']: 'โอนย้าย',
	['离开']: 'ออกจาก',
	['请选择服务对象开始通话']: 'กรุณาเลือกฝ่ายที่ต้องการติดต่อ',
	['请填写表单']: 'กรุณากรอกแบบฟอร์ม',
	['本对话已经结束']: 'การสนทนานี้สิ้นสุดลงแล้ว',
	['客服已逾 {{second}} 秒未回应']: 'ฝ่ายบริการลูกค้าไม่ตอบกลับนานกว่า {{second}}วินาที',
	['历史对话']: 'บทสนทนาทางประวัติศาสตร์',
	['查无资料']: 'ไม่พบข้อมูล',
	['标签']: 'ป้าย',
	['正在输入中...']: 'กำลังพิมพ์...',
	['于']: 'ที่',
	['档案容量限制']: 'จำกัด ขนาดไฟล์',
	['不能为空']: 'ต้องระบุค่า',
	['提交']: 'ส่ง',
	['满意度']: 'ระดับความพึงพอใจ',
	['IP未知']: 'ไม่สามารถทราบตำแหน่ง IP',
	['地区未知']: 'ไม่สามารถทราบภูมิภาคได้',
	['使用者环境未知']: 'ไม่สามารถทราบสภาพแวดล้อมของผู้ใช้',
	['关闭']: 'ปิด',
	['全萤幕截图成档案']: 'แคปหน้าจอทั้งหมดเป็นไฟล์',
	['Mac用户']: 'ผู้ใช้ Mac',
	['Windows用户']: 'ผู้ใช้งาน Windows',
	['Windows键']: 'ปุ่ม Windows',
	['全萤幕截图至剪贴簿']: 'แคปหน้าจอทั้งหมดลงคลิปบอร์ด',
	['截图完成后请直接于文字输入处贴上']: 'หลังจากจับภาพหน้าจอเสร็จแล้ว ให้กดวางที่ช่องพิมพ์ข้อความได้เลย',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'ใช้เครื่องมือจับภาพหน้าจอของ Windows หรือฟังก์ชันจับภาพของ QQ หลังจากจับภาพแล้ว กรุณากดวางลงในช่องพิมพ์ข้อความได้เลย',
	['截图']: 'ภาพหน้าจอ',
	['档案']: 'ไฟล์',
	['下载失败']: 'ดาวน์โหลดไม่สำเร็จ',
	['请输入分类名称']: 'กรุณาใส่ชื่อหมวดหมู่',
	['新增']: 'เพิ่ม',
	['更新']: 'อัพเดท',
	['请选择一个分类']: 'เลือกหมวดหมู่',
	['请输入标题']: 'กรุณาใส่ชื่อเรื่อง',
	['请输入内文']: 'กรุณาใส่ข้อความ',
	['请上传图片']: 'กรุณาอัพโหลดรูปภาพ',
	['快捷语']: 'การเลือกประโยคทั่วไปอย่างรวดเร็ว',
	['图片']: 'รูปภาพ',
	['管理分类']: 'การจัดการหมวดหมู่',
	['新增分类']: 'เพิ่มหมวดหมู่',
	['标题/内文']: 'ชื่อเรื่อง/ข้อความ',
	['分类']: 'หมวดหมู่',
	['编辑']: 'แก้ไข',
	['删除']: 'ลบ',
	['平台名称']: 'ชื่อแพลตฟอร์ม',
	['显示']: 'แสดง',
	['编辑服务平台']: 'แพลตฟอร์มการแก้ไข',
	['若有服务中的客户，无法关闭服务平台']: 'ไม่สามารถปิดแพลตฟอร์มที่ให้บริการลูกค้าได้',
	['确定']: 'ตกลง',
	['人员列表']: 'รายชื่อสมาชิก',
	['服务人数']: 'ปริมาณในการให้บริการ',
	['选择转接人员']: 'เลือกเพื่อนร่วมงานที่จะโอน',
	['按此上传图片']: 'คลิกที่นี่เพื่ออัพโหลดรูปภาพ',
	['确定要取消{{displayName}}协作邀请吗？']: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิก{{-displayName}}คำเชิญการทำงานร่วมกันของ',
	['确定要结束{{displayName}}的协作吗？']: 'คุณแน่ใจหรือไม่ว่าต้องการยุติการทำงานร่วมกัน{{-displayName}}ของ',
	['等待协作中']: 'รอความร่วมมือ',
	['协作中']: 'ความร่วมมือในความคืบหน้า',
	['负责人']: 'คนที่มีความรับผิดชอบ',
	['已选择']: 'เลือกแล้ว',
	['可协作人数已满']: 'การทำงานร่วมกันเต็มรูปแบบ',
	['选择协作人员']: 'เลือกผู้ทำงานร่วมกัน',
	['提示']: 'คำแนะนำ',
	['请输入讯息']: 'พิมพ์ข้อความ',
	['确定已經完成？']: 'แน่ใจนะว่าเสร็จแล้ว',
	['常用图片']: 'รูปภาพที่ใช้บ่อย',
	['用户']: 'ผู้ใช้',
	['个人']: 'ส่วนตัว',
	['公共']: 'สาธารณะ',
	['开始谈话']: 'เริ่มการสนทนา',
	['等待中']: 'ที่รอคอย',
	['客户已离开对话']: 'ลูกค้าออกจากการสนทนาแล้ว',
	['正在转接给']: 'โอนไปที่',
	['邀请你加入协作']: 'เชิญคุณเข้าร่วมความร่วมมือ',
	['请求转接']: 'ขอโอน',
	['正在服务中']: 'กำลังดำเนินการให้บริการ',
	['编辑平台']: 'แพลตฟอร์มการแก้ไข',
	['您的连线已中断']: 'คุณได้รับการตัดการเชื่อมต่อ',
	['正尝试重新连线']: 'กำลังพยายามเชื่อมต่ออีกครั้ง',
	['重新登入']: 'เข้าสู่ระบบอีกครั้ง',
	['请先登入']: 'กรุณาเข้าสู่ระบบก่อน',
	['帐号']: 'บัญชี',
	['帐号不能为空']: 'บัญชีต้องไม่ว่างเปล่า',
	['请输入帐号']: 'กรุณาใส่บัญชีของคุณ',
	['密码']: 'รหัสผ่าน',
	['密码不能为空']: 'ต้องการรหัสผ่าน',
	['请输入密码']: 'กรุณาใส่รหัสผ่าน',
	['登录']: 'เข้าสู่ระบบ',
	['客服系统客服端']: 'ส่วนต่อประสานการบริการลูกค้า',
	['平台异动，请重新整理']: 'มีการเปลี่ยนแปลงในแพลตฟอร์ม โปรดอัปเดต',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'ระบบบริการลูกค้ากำลังได้รับการอัปเกรดและบำรุงรักษา โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์ในภายหลัง ขอบคุณ',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'ระบบบริการลูกค้าอยู่ในขั้นตอนการอัปเกรดและบำรุงรักษา ฉันขอโทษที่ขัดจังหวะการสนทนาของคุณ โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์ในภายหลัง',
	['请稍后再试']: 'กรุณาลองใหม่อีกครั้งในภายหลัง',
	['是']: 'ใช่',
	['否']: 'ไม่ใช่',
	['等于']: 'เท่ากัน',
	['包含']: 'บรรจุ',
	['排除']: 'นอกจาก',
	['大于']: 'มากกว่า',
	['少于']: 'น้อยกว่า',
	['数量区间']: 'ช่วงปริมาณ',
	['客服对话数']: 'จำนวนการสนทนาการบริการลูกค้า',
	['客戶对话数']: 'จำนวนการสนทนากับลูกค้า',
	['即时资讯']: 'ข้อมูลทันที',
	['报表分析']: 'การวิเคราะห์รายงาน',
	['平均通话时间']: 'เวลาโทรเฉลี่ย',
	['回覆通话数']: 'จำนวนที่รับสาย',
	['平均等待时间']: 'เวลารอเฉลี่ย',
	['客户满意度']: 'ระดับความพึงพอใจลูกค้า',
	['历史对话记录']: 'บันทึกการสนทนาประวัติ',
	['操作日志']: 'บันทึกการทำงาน',
	['智能客服设定']: 'การตั้งค่าการบริการลูกค้าอัจฉริยะ',
	['机器人设定']: 'การตั้งค่าหุ่นยนต์',
	['版本管理']: 'การจัดการเวอร์ชัน',
	['档案总览']: 'ภาพรวมของไฟล์',
	['设定']: 'ติดตั้ง',
	['公司管理']: 'การจัดการ บริษัท',
	['维修管理']: 'การจัดการบำรุงรักษา',
	['一般设定']: 'การตั้งค่าทั่วไป',
	['公告管理']: 'การจัดการประกาศ',
	['帐号管理']: 'การจัดการบัญชี',
	['平台管理']: 'การจัดการแพลตฟอร์ม',
	['角色管理']: 'การจัดการบทบาท',
	['团队管理']: 'การจัดการทีม',
	['标签管理']: 'การจัดการแท็ก',
	['查询']: 'สอบถาม',
	['重置']: 'รีเซ็ต',
	['今天']: 'วันนี้',
	['昨天']: 'เมื่อวาน',
	['过去7天']: '7 วันที่ผ่านมา',
	['过去10天']: '10 วันที่ผ่านมา',
	['过去一个月']: 'เดือนที่ผ่านมา',
	['过去90天']: '90 วันที่ผ่านมา',
	['LOGO 预览']: 'ดูตัวอย่างโลโก้',
	['档案格式：PNG、JPG，长宽不超过']: 'รูปแบบไฟล์: PNG, JPG ความยาวและความกว้างไม่เกิน',
	['档案太大或格式不支援']: 'ไฟล์มีขนาดใหญ่เกินไปหรืออยู่ในรูปแบบที่ไม่รองรับ',
	['且档案大小不得大于']: 'และขนาดไฟล์ต้องไม่ใหญ่เกิน',
	['上传档案']: 'อัพโหลดไฟล์',
	['新增IP白名单成功']: 'เพิ่ม IP whitelist เรียบร้อยแล้ว',
	['删除IP白名单成功']: 'ลบรายการที่อนุญาตพิเศษของ IP เรียบร้อยแล้ว',
	['请输入欲查询的IP']: 'กรุณากรอก IP ที่ต้องการสอบถาม',
	['请输入IP']: 'กรุณาใส่ไอพี',
	['备注']: 'ข้อสังเกต',
	['备注不能为空']: 'หมายเหตุต้องไม่ว่างเปล่า',
	['请输入备注']: 'กรุณาใส่หมายเหตุ',
	['新增时间']: 'เพิ่มเวลา',
	['操作']: 'ปฏิบัติการ',
	['IP白名单']: 'รายการที่อนุญาต IP',
	['新增IP']: 'เพิ่มไอพี',
	['新增IP白名单']: 'เพิ่มรายการที่อนุญาต IP',
	['确定删除此IP?']: 'คุณแน่ใจหรือที่จะลบ IP นี้?',
	['平台']: 'แพลตฟอร์ม',
	['团队']: 'ทีม',
	['全体']: 'ทั้งหมด',
	['客服']: 'บริการลูกค้า',
	['客服系统']: 'ระบบบริการลูกค้า',
	['个人帐号设定']: 'การตั้งค่าบัญชีส่วนบุคคล',
	['最少6码']: 'ขั้นต่ำ 6 หลา',
	['最多20码']: 'มากถึง 20 หลา',
	['不能有空白']: 'ไม่มีช่องว่าง',
	['应至少包含1个英文和数字']: 'ควรมีภาษาอังกฤษและตัวเลขอย่างน้อย 1 ตัว',
	['公司名称']: 'ชื่อ บริษัท',
	['僅能输入英文和数字']: 'ใส่ได้เฉพาะภาษาอังกฤษและตัวเลขเท่านั้น',
	['应至少包含1个英文']: 'ควรมีภาษาอังกฤษอย่างน้อย 1 ตัว',
	['最少5码']: 'ขั้นต่ำ 5 หลา',
	['IP不能为空']: 'IP ต้องไม่ว่างเปล่า',
	['非IP位址']: 'ที่อยู่ที่ไม่ใช่ IP',
	['最多500个字']: 'สูงสุด 500 ตัวอักษร',
	['启用']: 'เปิดใช้งาน',
	['禁用']: 'พิการ',
	['对话量']: 'ปริมาณการสนทนา',
	['目前客户数']: 'จำนวนลูกค้าปัจจุบัน',
	['目前客服数']: 'จำนวนบริการลูกค้าปัจจุบัน',
	['接通对话量']: 'ปริมาณการสนทนาที่เชื่อมต่อ',
	['全部']: 'ทั้งหมด',
	['最近一天']: 'วันสุดท้าย',
	['最近一周']: 'อาทิตย์ที่แล้ว',
	['最近一月']: 'เดือนที่แล้ว',
	['新增过滤器']: 'เพิ่มตัวกรอง',
	['请输入模組名称']: 'กรุณาใส่ชื่อม็อด',
	['储存过滤模組']: 'โมดูลตัวกรองการจัดเก็บ',
	['读取过滤模組']: 'อ่านโมดูลตัวกรอง',
	['确定要删除模組']: 'คุณแน่ใจหรือไม่ว่าต้องการลบม็อด',
	['分钟']: 'นาที',
	['接通时间']: 'เวลาเชื่อมต่อ',
	['通话时间']: 'เวลาโทร',
	['请选择或输入时间']: 'กรุณาเลือกหรือป้อนเวลา',
	['等待时间']: 'รอเวลา',
	['对话搜寻']: 'ค้นหากล่องโต้ตอบ',
	['请输入对话']: 'กรุณาเข้าสู่การสนทนา',
	['客戶 ID']: 'รหัสลูกค้า',
	['请输入客戶ID']: 'กรุณากรอกรหัสลูกค้า',
	['对话浏览模式']: 'โหมดการเรียกดูกล่องโต้ตอบ',
	['筆']: 'ปากกา',
	['客服本名']: 'ชื่อจริงของฝ่ายบริการลูกค้า',
	['进入时间']: 'เวลาเข้า',
	['客服昵称']: 'ชื่อเล่นบริการลูกค้า',
	['客服系统管理端']: 'เทอร์มินัลการจัดการระบบบริการลูกค้า',
	['数量']: 'ปริมาณ',
	['尚未上传档案']: 'ยังไม่มีการอัพโหลดไฟล์',
	['输入文字']: 'ป้อนข้อความ',
	['请在此输入文字']: 'กรุณากรอกข้อความที่นี่',
	['添加项目']: 'เพิ่มรายการ',
	['请选择']: 'กรุณาเลือก',
	['新增文字']: 'เพิ่มข้อความ',
	['新增档案']: 'เพิ่มไฟล์',
	['選項']: 'ตัวเลือก',
	['勾选标题']: 'ตรวจสอบชื่อเรื่อง',
	['文字內容不能为空']: 'เนื้อหาข้อความต้องไม่ว่างเปล่า',
	['添加']: 'เพิ่ม',
	['上传标题']: 'อัพโหลดหัวข้อ',
	['单选标题']: 'ชื่อเรื่องวิทยุ',
	['输入框标题']: 'ชื่อช่องใส่',
	['请输入']: 'โปรดกรอก',
	['输入框']: 'ช่องใส่',
	['单选']: 'วิทยุ',
	['核取方块']: 'กล่องกาเครื่องหมาย',
	['请选择一个标签']: 'โปรดเลือกป้ายกำกับ',
	['确定要删除此项目和其所有子项目？']: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้และรายการย่อยทั้งหมด',
	['答案']: 'คำตอบ',
	['表单']: 'รูปร่าง',
	['清除此阶层设定']: 'ล้างการตั้งค่าสำหรับลำดับชั้นนี้',
	['请输入此阶层问题']: 'กรุณากรอกคำถามในชั้นเรียนนี้',
	['新增选项']: 'ตัวเลือกใหม่',
	['新增表单']: 'เพิ่มแบบฟอร์ม',
	['新增答案']: 'เพิ่มคำตอบ',
	['新增充值表单']: 'แบบฟอร์มเติมเงินใหม่',
	['若切换种类后, 将清除原有的和其子项目资料']: 'หากเปลี่ยนประเภท ข้อมูลต้นฉบับและข้อมูลรายการย่อยจะถูกล้าง',
	['确定要清除所有资料和其子项目资料？']: 'คุณแน่ใจหรือไม่ว่าต้องการล้างข้อมูลทั้งหมดและข้อมูลรายการย่อย',
	['阶层']: 'ระดับ',
	['开场语']: 'กล่าวเปิดงาน',
	['开场语不能为空']: 'คำเปิดต้องไม่เว้นว่าง',
	['结尾感谢语']: 'ปิดครับ ขอบคุณครับ',
	['结尾感谢语不能为空']: 'การปิดคำขอบคุณต้องไม่ว่างเปล่า',
	['发布']: 'ปล่อย',
	['复制']: 'สำเนา',
	['选择目的平台']: 'เลือกแพลตฟอร์มเป้าหมาย',
	['确定复制到']: 'ตกลงเพื่อคัดลอกไปยัง',
	['是否要正式发布到使用环境？']: 'คุณต้องการปล่อยอย่างเป็นทางการสู่สภาพแวดล้อมการใช้งานหรือไม่?',
	['储存版本']: 'บันทึกเวอร์ชัน',
	['版本名称']: 'ชื่อรุ่น',
	['请输入版本名称']: 'โปรดป้อนชื่อเวอร์ชัน',
	['确定是否储存此版本']: 'กำหนดว่าจะบันทึกเวอร์ชันนี้หรือไม่',
	['版本储存成功']: 'บันทึกเวอร์ชันเรียบร้อยแล้ว',
	['最多10个字']: 'สูงสุด 10 ตัวอักษร',
	['公告一']: 'ประกาศที่หนึ่ง',
	['公告二']: 'ประกาศ 2',
	['公告三']: 'ประกาศ สาม',
	['公告储存成功']: 'บันทึกประกาศเรียบร้อยแล้ว',
	['标题']: 'ชื่อ',
	['內文']: 'ข้อความ',
	['修改登入密码']: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
	['修改基本资讯']: 'แก้ไขข้อมูลพื้นฐาน',
	['昵称']: 'ชื่อเล่น',
	['昵称不能为空']: 'ควรกรอกชื่อเล่น',
	['请输入昵称']: 'กรุณาใส่ชื่อเล่น',
	['本名']: 'ชื่อจริง',
	['本名不能为空']: 'ชื่อจริงต้องไม่ว่างเปล่า',
	['请输入本名']: 'กรุณาใส่ชื่อจริงของคุณ',
	['选择图像']: 'เลือกภาพ',
	['状态']: 'สถานะ',
	['平台代码']: 'รหัสแพลตฟอร์ม',
	['平台代码不能为空']: 'รหัสแพลตฟอร์มต้องไม่ว่างเปล่า',
	['使用ID模式登入']: 'เข้าสู่ระบบด้วยโหมด ID',
	['新增平台']: 'แพลตฟอร์มใหม่',
	['修改平台']: 'ปรับเปลี่ยนแพลตฟอร์ม',
	['确定重新产生Key/IV?']: 'คุณแน่ใจหรือที่จะสร้างคีย์/IV ใหม่',
	['进入公司成功']: 'เข้าบริษัทเรียบร้อย',
	['确定禁用公司?']: 'คุณแน่ใจหรือไม่ว่าจะปิดการใช้งานบริษัท',
	['确定启用公司?']: 'คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งานบริษัท',
	['修改公司']: 'แก้ไขบริษัท',
	['进入公司']: 'เข้าบริษัท',
	['确定进入公司?']: 'คุณแน่ใจหรือว่าต้องการเข้าร่วมบริษัท?',
	['新增标签']: 'เพิ่มป้ายกำกับ',
	['代号']: 'รหัสชื่อ',
	['代号不可为空']: 'ชื่อรหัสต้องไม่ว่างเปล่า',
	['名称']: 'ชื่อ',
	['名称不可为空']: 'ชื่อต้องไม่ว่างเปล่า',
	['颜色']: 'สี',
	['颜色不可为空']: 'สีต้องไม่ว่างเปล่า',
	['进入标签']: 'เข้าสู่แท็บ',
	['修改标签']: 'แก้ไขฉลาก',
	['确定开启进入标签?']: 'คุณแน่ใจหรือไม่ว่าต้องการเปิดแท็บการเข้าถึง',
	['确定关闭进入标签?']: 'คุณแน่ใจหรือไม่ว่าต้องการปิดแท็บรายการ',
	['确定删除此标签?']: 'คุณแน่ใจหรือไม่ว่าต้องการลบแท็กนี้',
	['标签创建成功']: 'สร้างแท็กสำเร็จแล้ว',
	['标签更新成功']: 'อัปเดตป้ายกำกับเรียบร้อยแล้ว',
	['进入标签更新成功']: 'ป้อนป้ายกำกับที่อัปเดตเรียบร้อยแล้ว',
	['标签删除成功']: 'ลบป้ายกำกับเรียบร้อยแล้ว',
	['请输入代号、名称等关键字']: 'กรุณากรอกรหัส ชื่อ และคำสำคัญอื่นๆ',
	['设定开场白成功']: 'กำหนดอารัมภบทสำเร็จ',
	['客戶进入开场白']: 'ลูกค้าป้อนคำกล่าวเปิดงาน',
	['客戶进入开场白不可为空']: 'ลูกค้าป้อนคำสั่งเปิดและไม่สามารถเว้นว่างได้',
	['第一次通知时间']: 'เวลาแจ้งให้ทราบล่วงหน้า',
	['第{{count}}次通知时间']: '{{count}} เวลาแจ้งเตือน',
	['设置错误']: 'ข้อผิดพลาดในการตั้งค่า',
	['设定等待过长通知时间成功']: 'ตั้งเวลารอสำหรับการแจ้งเตือนที่นานเกินไปได้สำเร็จ',
	['秒']: 'ที่สอง',
	['对话自动断开时间']: 'เวลาตัดการเชื่อมต่ออัตโนมัติของไดอะล็อก',
	['未发话时间']: 'เวลาเงียบ',
	['未发话提示文字']: 'ไม่ใช่ข้อความพรอมต์พูด',
	['设定对话断开成功']: 'ตั้งค่าไดอะล็อกยกเลิกการเชื่อมต่อเรียบร้อยแล้ว',
	['Favicon预览']: 'ตัวอย่าง Favicon',
	['更换 Favicon 成功']: 'แทนที่ Favicon เรียบร้อยแล้ว',
	['档案格式：ICO，長寬不超過 32x32 px']: 'รูปแบบไฟล์: ICO ความสูงและความกว้างไม่เกิน 32x32 px',
	['更换 LOGO 成功']: 'เปลี่ยนโลโก้สำเร็จแล้ว',
	['智能客服']: 'ผู้ช่วยอัจฉริยะ',
	['设定通道成功']: 'ตั้งค่าช่องเรียบร้อยแล้ว',
	['设定提示音效成功']: 'ตั้งค่าเอฟเฟกต์เสียงพรอมต์สำเร็จ',
	['单音']: 'โมโนโฟนิก',
	['循环音']: 'เสียงวนรอบ',
	['编号']: 'หมายเลขซีเรียล',
	['资料类型']: 'ประเภทข้อมูล',
	['资料类型不可为空']: 'ชนิดข้อมูลต้องไม่ว่างเปล่า',
	['数字']: 'ตัวเลข',
	['字串']: 'สตริง',
	['布林']: 'บริน',
	['建立标签成功']: 'สร้างแท็กสำเร็จ',
	['修改标签成功']: 'แก้ไขฉลากเรียบร้อยแล้ว',
	['删除标签成功']: 'ลบป้ายกำกับสำเร็จ',
	['更换 LOGO']: 'เปลี่ยนโลโก้',
	['更换 Favicon']: 'แทนที่ Favicon',
	['对话断开']: 'การสนทนาถูกตัดการเชื่อมต่อ',
	['等待过长通知时间']: 'รอการแจ้งเตือนนานเกินไป',
	['开场白']: 'อารัมภบท',
	['提示音效设定']: 'แจ้งการตั้งค่าเสียง',
	['通道设定']: 'การตั้งค่าช่อง',
	['自定义标签']: 'ฉลากที่กำหนดเอง',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'การเปิดโหมดการบำรุงรักษาจะทำให้ระบบบริการลูกค้าหยุดทำงาน แน่ใจไหมว่าต้องการเปิด',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'ปิดโหมดการบำรุงรักษา และระบบบริการลูกค้าจะทำงานต่อไป คุณแน่ใจหรือว่าจะปิด?',
	['状态更新成功']: 'อัปเดตสถานะสำเร็จแล้ว',
	['通知讯息更新成功']: 'อัปเดตข้อความแจ้งเตือนสำเร็จแล้ว',
	['维修模式']: 'โหมดการบำรุงรักษา',
	['通知讯息设定']: 'การตั้งค่าข้อความแจ้งเตือน',
	['尚未连线状态']: 'ยังไม่ได้เชื่อมต่อ',
	['尚未连线状态描述']: 'ยังไม่ได้เชื่อมต่อคำอธิบายสถานะ',
	['已连线状态']: 'เชื่อมต่อ',
	['已连线状态描述']: 'คำอธิบายสถานะการเชื่อมต่อ',
	['开启成功']: 'เปิดสำเร็จ',
	['关闭成功']: 'ปิดเรียบร้อยแล้ว',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'การปิดโหมดการจัดการการเข้าสู่ระบบจะจำกัดไม่ให้ลูกค้าเข้าสู่บริการลูกค้าด้วยการป้อน ID คุณแน่ใจหรือไม่ว่าต้องการปิด (หากคุณไม่ระบุข้อมูลโปรไฟล์ลูกค้า คุณจะเข้าสู่หน้าข้อผิดพลาด)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'การเปิดใช้งานโหมดการจัดการการเข้าสู่ระบบจะทำให้ลูกค้าเข้าสู่การบริการลูกค้าโดยป้อน ID ของพวกเขา คุณแน่ใจหรือไม่ว่าต้องการเปิดใช้งาน',
	['请输入帐号、昵称、角色等关键字']: 'กรุณาป้อนคำหลัก เช่น หมายเลขบัญชี ชื่อเล่น บทบาท ฯลฯ',
	['新增角色']: 'บทบาทใหม่',
	['修改角色']: 'แก้ไขบทบาท',
	['角色创建成功']: 'สร้างบทบาทสำเร็จแล้ว',
	['角色更新成功']: 'อัปเดตบทบาทเรียบร้อยแล้ว',
	['角色删除成功']: 'ลบบทบาทเรียบร้อยแล้ว',
	['请输入角色名称，平台，权限等关键字']: 'โปรดป้อนคำหลัก เช่น ชื่อบทบาท แพลตฟอร์ม สิทธิ์ ฯลฯ',
	['关键字']: 'คำหลัก',
	['角色名称']: 'ชื่อบทบาท',
	['角色名称不可为空']: 'ชื่อบทบาทต้องไม่ว่างเปล่า',
	['请输入角色名称']: 'โปรดป้อนชื่อบทบาท',
	['上级角色']: 'บทบาทที่เหนือกว่า',
	['上级角色不可为空']: 'ต้องระบุบทบาทที่เหนือกว่า',
	['权限']: 'สิทธิ์',
	['确定删除此角色?']: 'คุณแน่ใจหรือไม่ว่าต้องการลบบทบาทนี้',
	['图像不能为空']: 'รูปภาพต้องไม่ว่างเปล่า',
	['新增团队']: 'เพิ่มทีมใหม่',
	['修改团队']: 'แก้ไขทีม',
	['团队创建成功']: 'สร้างทีมสำเร็จแล้ว',
	['团队修改成功']: 'ทีมงานแก้ไขเรียบร้อยแล้ว',
	['团队删除成功']: 'ลบทีมเรียบร้อยแล้ว',
	['人数']: 'จำนวนคน',
	['新登入密码']: 'รหัสผ่านเข้าสู่ระบบใหม่',
	['新密码不能设定與舊密码相同']: 'ไม่สามารถตั้งรหัสผ่านใหม่เหมือนกับรหัสผ่านเดิมได้',
	['新密码與確認密码不相同']: 'รหัสผ่านใหม่ไม่เหมือนกับรหัสผ่านยืนยัน',
	['确定修改登入密码?']: 'คุณแน่ใจหรือว่าเปลี่ยนรหัสผ่านเข้าสู่ระบบ?',
	['登入密码修改成功，请重新登入']: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง',
	['个人资讯']: 'ข้อมูลส่วนบุคคล',
	['搜寻快捷语']: 'ทางลัดการค้นหา',
	['登出']: 'ออกจากระบบ',
	['帐密错误']: 'ข้อผิดพลาดรหัสผ่านบัญชี',
	['一']: 'หนึ่ง',
	['二']: 'สอง',
	['三']: 'สาม',
	['四']: 'สี่',
	['五']: 'ห้า',
	['六']: 'หก',
	['七']: 'เจ็ด',
	['请输入客服本名、客服昵称等关键字']: 'กรุณาป้อนชื่อฝ่ายบริการลูกค้า ชื่อเล่นฝ่ายบริการลูกค้า และคำหลักอื่นๆ',
	['共 {{count}} 筆资料']: 'ทั่วไป{{count}}ข้อมูลปากกา',
	['平台语言不能为空']: 'ภาษาแพลตฟอร์มต้องไม่ว่างเปล่า',
	['开启']: 'เปิด',
	['语言']: 'ภาษา',
	['切换语言']: 'เปลี่ยนภาษา',
	['语言名称']: 'ชื่อภาษา',
	['系统设定']: 'โปรแกรมระบบ',
	['储存成功']: 'บันทึกเรียบร้อยแล้ว',
	['发布成功']: 'เผยแพร่เรียบร้อยแล้ว',
	['复制成功']: 'คัดลอกสำเร็จ',
	['项目选取']: 'การเลือกรายการ',
	['图像']: 'ภาพ',
	['角色']: 'บทบาท',
	['新增帐号']: 'เพิ่มบัญชี',
	['角色不能为空']: 'ต้องระบุบทบาท',
	['登入密码']: 'รหัสผ่านการเข้าใช้งาน',
	['请输入代号、名称、备注等关键字']: 'กรุณากรอกรหัส ชื่อ หมายเหตุ และคำหลักอื่นๆ',
	['确定删除此团队?']: 'คุณแน่ใจหรือไม่ว่าต้องการลบทีมนี้',
	['切换语言成功']: 'เปลี่ยนภาษาสำเร็จ',
	['确定要切换语言?']: 'คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนภาษา',
	['选项']: 'ตัวเลือก',
	['选择语言']: 'เลือกภาษา',
	['修改成功']: 'แก้ไขเรียบร้อยแล้ว',
	['舊登入密码']: 'รหัสผ่านเข้าสู่ระบบเก่า',
	['確認新登入密码']: 'ยืนยันรหัสผ่านเข้าสู่ระบบใหม่',
	['语言切换成功，將重整页面以套用更新']: 'การเปลี่ยนภาษาสำเร็จ หน้าจะถูกรีเฟรชเพื่อใช้การอัปเดต',
	['笔 / 页']: 'ชุด / หน้า',
	['时段搜寻']: 'ค้นหาช่วงเวลา',
	['请选择时段']: 'กรุณาเลือกช่วงเวลา',
	['更换背景色']: 'เปลี่ยนสีพื้นหลัง',
	['设定背景颜色成功']: 'กำหนดสีพื้นหลังสำเร็จ',
	['请重新登入']: 'กรุณาเข้าสู่ระบบอีกครั้ง',
	['绑定谷歌验证']: 'ผูกการยืนยันของ Google',
	['解除绑定']: 'ปลด',
	['谷歌验证状态']: 'สถานะการยืนยันของ Google',
	['已绑定']: 'ผูกพัน',
	['未绑定']: 'หลุด',
	['解绑谷歌验证失败']: 'การยกเลิกการเชื่อมโยงการรับรองความถูกต้องของ Google ล้มเหลว',
	['二维码方式添加']: 'เพิ่มด้วยคิวอาร์โค้ด',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'โปรดเพิ่มบาร์โค้ดใน Google Authenticator',
	['密钥方式添加']: 'วิธีสำคัญในการเพิ่ม',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'โปรดเพิ่มใน Google Authenticator โดยป้อนรหัสที่ให้ไว้',
	['密钥如下所示']: 'หน้าตากุญแจเป็นแบบนี้',
	['请再次输入登入密码']: 'กรุณากรอกรหัสผ่านเข้าสู่ระบบอีกครั้ง',
	['谷歌6位动态密码']: 'รหัสผ่านแบบไดนามิก 6 หลักของ Google',
	['请绑定谷歌验证']: 'โปรดผูกการยืนยันของ Google',
	['谷歌验证绑定成功']: 'การเชื่อมโยงการยืนยันของ Google สำเร็จ',
	['解绑谷歌验证成功']: 'เลิกผูกการยืนยันของ Google สำเร็จ',
	['确定解绑谷歌验证？']: 'คุณแน่ใจหรือไม่ที่จะยกเลิกการเชื่อมโยงการยืนยันของ Google',
	['请输入谷歌动态码']: 'โปรดป้อนรหัสไดนามิกของ Google',
	['谷歌动态码']: 'รหัสไดนามิกของ Google',
	['谷歌动态码不能为空']: 'รหัสไดนามิกของ Google ต้องไม่ว่างเปล่า',
	['谷歌动态码长度6码']: 'ความยาวรหัสไดนามิกของ Google 6 หลา',
	['谷歌动态码错误']: 'ข้อผิดพลาดรหัสไดนามิกของ Google',
	['內容']: 'เนื้อหา',
	['搜寻']: 'ค้นหา',
	['连线中断，点击“确定”即重新连线客服。']: 'หากการเชื่อมต่อถูกขัดจังหวะ ให้คลิก "ตกลง" เพื่อเชื่อมต่อกับฝ่ายบริการลูกค้าอีกครั้ง',
	['充值表单']: 'แบบเติมเงิน',
	['网银充值']: 'เติมเงินผ่านธนาคารออนไลน์',
	['扫码充值']: 'สแกน QR Code เพื่อเติมเงิน',
	['带入目前帐号']: 'นำเข้าบัญชีกระแสรายวัน',
	['自行输入平台帐号']: 'เข้าสู่บัญชีแพลตฟอร์มด้วยตัวเอง',
	['充值方式']: 'ช่องทางการเติมเงิน',
	['平台帐号']: 'บัญชีแพลตฟอร์ม',
	['充值金额']: 'จำนวนเงินที่เติม',
	['付款人姓名']: 'ชื่อผู้จ่าย',
	['确认语']: 'การยืนยัน',
	['操作时间']: 'เวลาในการทำงาน',
	['操作者']: 'ผู้ประกอบการ',
	['请输入备注等关键字']: 'กรุณาใส่คำหลัก เช่น ข้อสังเกต',
	['操作类型']: 'ประเภทการดำเนินการ',
	['修改平台昵称']: 'แก้ไขชื่อเล่นของแพลตฟอร์ม',
	['修改平台昵称成功']: 'แก้ไขชื่อเล่นแพลตฟอร์มสำเร็จ',
	['输入格式错误']: 'รูปแบบการป้อนข้อมูลที่ไม่ถูกต้อง',
	['套用']: 'เพื่อนำไปใช้',
	['确定套用到']: 'ตกลงที่จะสมัคร',
	['套用成功']: 'สมัครเรียบร้อย',
	['储存方式']: 'วิธีการจัดเก็บ',
	['储存時間']: 'เวลาเก็บ',
	['系统发布']: 'การเปิดตัวระบบ',
	['手动储存']: 'บันทึกด้วยตนเอง',
	['自动储存']: 'บันทึกอัตโนมัติ',
	['预览']: 'ดูตัวอย่าง',
	['最多350个字']: 'สูงสุด 350 ตัวอักษร',
	['修改']: 'ปรับปรุงใหม่',
	['共同资讯管理']: 'การจัดการข้อมูลทั่วไป',
	['共同资讯创建成功']: 'สร้างข้อมูลทั่วไปสำเร็จแล้ว',
	['共同资讯修改成功']: 'แก้ไขข้อมูลทั่วไปเรียบร้อยแล้ว',
	['新增共同资讯']: 'เพิ่มข้อมูลทั่วไป',
	['修改共同资讯']: 'แก้ไขข้อมูลทั่วไป',
	['删除成功']: 'ลบเรียบร้อยแล้ว',
	['已设置于其他答案，无法删除']: 'ถูกตั้งค่าในคำตอบอื่นและไม่สามารถลบได้',
	['请输入名称、内容等关键字']: 'กรุณาป้อนคำหลัก เช่น ชื่อและเนื้อหา',
	['确定删除此共同资讯？']: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลทั่วไปนี้',
	['共同资讯']: 'ข้อมูลทั่วไป',
	['尚未选择共同资讯']: 'ไม่ได้เลือกข้อมูลทั่วไป',
	['选择共同资讯']: 'เลือกข้อมูลทั่วไป',
	['选择']: 'เลือก',
	['点击「确定」后，即覆盖该平台的快捷语设定']: 'หลังจากกด"ยืนยัน"การตั้งค่าทางลัดแพลตฟอร์มจะถูกแทนที่',
	['已复制：目的平台']: 'คัดลอก: แพลตฟอร์มปลายทาง',
	['是否离开客服系统？']: 'คุณต้องการออกจากระบบบริการลูกค้าหรือไม่?',
	['感谢您的作答，此次评分为：{{score}}分']: 'ขอบคุณสำหรับคำตอบ คะแนนในครั้งนี้คือ: {{score}} คะแนน',
	['共 {{count}} 筆']: 'ทั่วไป {{count}} ข้อมูลปากกา',
	['分']: 'ดาว',
	['新增公司']: 'เพิ่มบริษัท',
	['翻译']: 'แปล',
	['显示原文']: 'แสดงข้อความต้นฉบับ',
	['解绑谷歌验证']: 'ยกเลิกการผูกยืนยัน Google',
	['请输入名称 内容等关键字']: 'กรุณาป้อนคำหลัก เช่น ชื่อและเนื้อหา',
	['表单选项']: 'รายการตัวเลือก',
	['年']: 'ปี',
	['等待时间颜色设定']: 'ตั้งค่าสีของเวลาการรอ',
	['显示颜色']: 'สีที่แสดง',
	['确认删除此规则?']: 'ยืนยันที่จะลบกฎนี้หรือไม่',
	['页签']: 'แท็บ',
	['超过 {{time}} 分钟']: 'เกิน {{-time}} นาที',
	['新增成功']: 'เพิ่มสำเร็จ',
	['删除完成']: 'ลบสำเร็จ',
	['等待时间(分钟)']: 'เวลารอ(นาที)',
	['时间']: 'เวลา',
	['不可为空']: 'ไม่สามารถเว้นว่าง',
	['需为正整数']: 'จำเป็นต้องเป็นจำนวนเต็ม',
	['按平台名称排列(A-Z)']: 'จัดเรียงตามชื่อแพลตฟอร์ม (A-Z)',
	['按平台名称排列(Z-A)']: 'จัดเรียงตามชื่อแพลตฟอร์ม (Z-A)',
	['旧版面模式']: 'โหมดเค้าโครงเดิม',
	['自动翻译']: 'แปลอัตโนมัติ',
	['功能設定']: 'ตั้งค่าฟังก์ชัน',
	['确认切换版面？']: 'ยืนยันที่จะเปลี่ยนเค้าโครงหรือไม่',
	['确认开启自动翻译？']: 'ยืนยันที่จะเปิดใช้งานแปลอัตโนมัติหรือไม่',
	['确认关闭自动翻译？']: 'ยืนยันที่จะปิดใช้งานแปลอัตโนมัติหรือไม่',
	['原文']: 'ภาษาเดิม',
	['泰语']: 'ภาษาไทย',
	['追踪']: 'ติดตาม',
	['取消追踪']: 'ยกเลิกติดตาม',
	['预览影片']: 'ดูภาพวีดิโอ',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'อัปโหลดไฟล์ MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF ได้เท่านั้น',
	['请勿输入语法相关字串']: 'กรุณาอย่าป้อนอักขระพิเศษหรือโค้ดคำสั่ง',
	['输入名称']: 'กรุณากรอกชื่อ',
	['设为预设版本']: 'ตั้งค่าเป็นเวอร์ชันเริ่มต้น',
	['另存为新版本']: 'บันทึกเป็นเวอร์ชันใหม่',
	['请选择版本']: 'โปรดเลือกเวอร์ชัน',
	['一键开关']: 'ปุ่มเปิดปิด',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'หากลูกค้าที่อยู่ในบริการ ไม่สามารถปิดแพลตฟอร์มบริการหรือเปลี่ยนเวอร์ชันได้',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'แน่ใจหรือไม่ว่าจะแทนที่การตั้งค่าเดิม พร้อมบันทึกการตั้งค่าใหม่',
	['已储存超过五个版本']: 'ได้ถูกบันทึกแล้วเกินห้าเวอร์ชัน',
	['版本已变动，是否需要储存？']: 'เวอร์ชันเกิดการเปลี่ยนแปลง จะบันทึกหรือไม่',
	['确定删除此版本？']: 'แน่ใจหรือไม่ว่าจะลบเวอร์ชันนี้',
	['编辑版本']: 'แก้ไขเวอร์ชัน',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'ตรวจพบการติดต่อระบบบริการลูกค้าซ้ำซ้อน หากไม่ใช่ท่าน กรุณาแจ้งเจ้าหน้าที่',
	['删除此版本']: 'ลบเวอร์ชันนี้',
	['刪除成功']: 'ลบสำเร็จ',
	['刪除失敗']: 'ลบไม่สำเร็จ',
	['儲存成功']: 'บันทึกสำเร็จ',
	['儲存失敗']: 'บันทึกไม่สำเร็จ',
	['您好，请问要选择哪个问题？']: 'สวัสดีค่ะ ต้องการสอบถามหัวข้อใดคะ',
	['等待服务区']: 'พื้นที่รอบริการ',
	['按时间排列(長到短)']: 'จัดวางตามเวลา(มากไปน้อย)',
	['按时间排列(短到長)']: 'จัดวางตามเวลา(น้อยไปมาก)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'สวัสดีค่ะ ยินดีต้อนรับนะคะ เรายินดีเป็นอย่างยิ่งที่ได้ให้บริการท่าน กรุณารอสักครู่ เรากำลังจะเริ่มให้บริการท่านในไม่ช้าค่ะ',
	['编辑标签']: 'แก้ไขแท็บ',
	['于 {{time}} 侦测到会员【稍早已离线】']: 'ตรวจพบว่าสมาชิก (ออฟไลน์) {{-time}} เมื่อสักครู่นี้',
	['{{score}}分']: '{{score}}คะแนน',
	['未评分']: 'ไม่มีคะแนน',
	['客服完成']: 'บริการเสร็จสิ้น',
	['会员离线']: 'สมาชิกออฟไลน์',
	['超时自动断线']: 'หมดเวลาตัดการเชื่อมต่ออัตโนมัติ',
	['{{text}}不可重复']: '{{-text}}ห้ามซ้ำ',
	['{{text}}不能为空']: '{{-text}}ห้ามเว้นว่าง',
	['{{text}}设置错误']: '{{-text}}ข้อผิดพลาดในการตั้งค่า',
	['平均通话时长']: 'ระยะเวลาการโทรโดยเฉลี่ย',
	['平均通话数']: 'จำนวนการโทรโดยเฉลี่ย',
	['请选择角色名称']: 'โปรดเลือกชื่อตัวละคร',
	['请选择客服']: 'กรุณาเลือกฝ่ายบริการลูกค้า',
	['请选择团队']: 'กรุณาเลือกทีม',
	['播放']: 'เปิด',
	['统计时间']: 'สถิติเวลา',
	['统计时间不可为空']: 'สถิติเวลาห้ามเว้นว่าง',
	['请输入时间']: 'กรุณาป้อนเวลา',
	['时间筛选']: 'คัดกรองเวลา',
	['汇出']: 'ส่งออก',
	['未出勤']: 'ไม่ได้เข้าร่วม',
	['客服平均通话时长']: 'ระยะเวลาการโทรโดยเฉลี่ยฝ่ายบริการลูกค้า',
	['数量筛选']: 'คัดกรองจำนวน',
	['客服平均等待时间']: 'ระยะเวลาการรอโดยเฉลี่ยฝ่ายบริการลูกค้า',
	['上一个月']: 'เดือนที่แล้ว',
	['导出Excel成功']: 'ส่งออก Excel สำเร็จ',
	['对话结束']: 'จบการสนทนา',
	['满意度/客服']: 'ความพึงพอใจ / บริการลูกค้า',
	['日期/客服']: 'วันที่ / บริการลูกค้า',
	['总数']: 'จำนวนรวม',
	['日平均']: 'เฉลี่ยรายวัน',
	['客服日均量']: 'บริการลูกค้าโดยเฉลี่ยต่อวัน',
	['客服通话总量']: 'จำนวนสนทนาฝ่ายบริการลูกค้าทั้งหมด',
	['日总量']: 'ยอดรวมรายวัน',
	['请输入数量']: 'กรุณาระบุจำนวน',
	['满意度预设分数']: 'คะแนนระดับความพึงพอใจเริ่มต้น',
	['当会员未评分，会自动给予此预设分数。']: 'เมื่อสมาชิกไม่ได้ให้คะแนน จะได้รับคะแนนเริ่มต้นโดยอัตโนมัติ',
	['设定满意度预设分数成功']: 'ตั้งค่าคะแนนความพึงพอใจเริ่มต้นสำเร็จ',
	['客户满意度管理']: 'จัดการความพึงพอใจลูกค้า',
	['对话结束方式']: 'วิธีหยุดสนทนา',
	['对话满意度']: 'ระดับความพึงพอใจต่อสนทนา',
	['时段']: 'ช่วงเวลา',
	['客服平均满意度']: 'ระดับความพึงพอใจเฉลี่ยต่อฝ่ายบริการ',
	['公用设定']: 'ตั้งค่าส่วนรวม',
	['通话时长']: 'ระยะเวลาสนทนา',
	['服务时段']: 'ระยะเวลาให้บริการ',
	['储存时间']: 'เวลาที่บันทึก',
	['客服不可为空']: 'ฝ่ายบริการห้ามเว้นว่าง',
	['团队不可为空']: 'ทีมห้ามเว้นว่าง',
	['请输入对话内容关键字']: 'โปรดกรอกคีย์เวิร์ดเนื้อหาสนทนา',
	['请输入客服本名、昵称或帐号']: 'โปรดกรอกชื่อจริง, นามแฝงหรือบัญชีฝ่ายบริการ',
	['平台不可为空']: 'แพลตฟอร์ตห้ามว่างเว้น',
	['线上']: 'ออนไลน์',
	['离线']: 'ออฟไลน์',
	['日期不可为空']: 'วันที่ไม่สามารถเว้นว่าง',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'ยืนยันที่จะเติมเงินในบัญชี{{chargeAccount}}เป็นจำนวน{{chargeNumber}}บาทใช่หรือไม่',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'คุณอยู่ในคิวลำดับที่ {{pendingOrder}}',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: 'ปฎิเสธการถ่ายโอนจาก {{-inviter}} ไปยัง {{-invitee}}',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{-name}} ปิดหน้าต่างเมื่อ {{-time}}',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{-name}} คลิกเสร็จสมบูรณ์เมื่อ {{-time}}',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{-name}} เข้าร่วมการทำงานร่วมกันสำเร็จเมื่อ {{-time}}',
	['{{name}} 已于 {{time}} 离开协作']: '{{-name}} ออกจากการทำงานร่วมกันเมื่อ {{-time}}',
	['{{name}} 已于 {{time}} 中断连线']: '{{-name}} ขาดจากการเชื่อมต่อเมื่อ {{-time}}',
	['英文']: 'ภาษาอังกฤษ',
	['验证码设定']: 'ตั้งค่ารหัสยืนยัน',
	['启用验证码']: 'เปิดใช้รหัสยืนยัน',
	['设定验证码成功']: 'ตั้งค่ารหัสยืนยันสำเร็จ',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'หลังจากเปิดใช้งานฟังก์ชันรหัสยืนยันแล้ว ลูกค้าต้องทำการการยืนยันก่อนเข้าไปยังพื้นที่รอคอยของระบบบริการลูกค้า',
	['禁止连续发话']: 'ห้ามส่งข้อความรัวต่อเนื่อง',
	['启用禁止连续发话']: 'เปิดใช้งานห้ามสนทนาต่อเนื่อง',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'ระบบจะแจ้งเตือนโดยอัตโนมัติเมื่อสมาชิกส่งข้อความเกินจำนวนที่กำหนดภายใน "จำนวนวินาทีจำกัด"',
	['客户端限制于']: 'เวลาจำกัดลูกค้า',
	['发话次数达到']: 'ถึงจำนวนการสนทนา',
	['次']: 'ครั้ง',
	['暂时无法发话']: 'ไม่สามารถสนทนาได้ชั่วคราว',
	['储存完成']: 'บันทึกสำเร็จ',
	['发送消息过于频繁 可稍后再试']: 'ส่งข้อมูลถี่เกินไป กรุณาลองใหม่อีกสักครู่',
	['IP黑名单管理']: 'จัดการ IP บัญชีดำ',
	['共 {{total}} 笔']: 'ทั้งหมด {{total}} รายการ',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: 'รายการที่ {{min}} - {{max}} / รวม {{total}} รายการ',
	['顯示']: 'แสดง',
	['查询IP黑名单']: 'ค้นหา IP บัญชีดำ',
	['设定自动添加黑名单']: 'ตั้งค่าการเพิ่มบัญชีดำโดยอัตโนมัติ',
	['白名單管理']: 'จัดการบัญชีขาว',
	['解除时间']: 'เวลาปลดล็อค',
	['永久封锁']: 'ปิดกั้นถาวร',
	['新增IP黑名单']: 'เพิ่ม IP บัญชีดำ',
	['加入黑名单后，该IP将无法进入客服前台。']: 'หลังจากขึ้นบัญชีดำแล้ว IP นี้จะไม่สามารถเข้าถึงแผนกบริการลูกค้าได้',
	['请完成安全验证']: 'กรุณายืนยันความปลอดภัย',
	['向右滑动填充拼图']: 'เลื่อนไปทางขวาเพื่อต่อจิ๊กซอว์',
	['启用功能']: 'เปิดใช้ฟังก์ชัน',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'หากIPเข้าสู่ระบบภายใน"เวลาจํากัด"เกิน"จํานวนการเข้าสู่ระบบ"ที่กําหนดไว้จะถูกเพิ่มลงในบัญชีดําโดยอัตโนมัติ',
	['限制时间']: 'เวลาจำกัด',
	['时间单位不可为空']: 'หน่วยเวลาไม่สามารถเว้นว่าง',
	['时间单位']: 'หน่วยเวลา',
	['登入次数']: 'จำนวนครั้งที่ล็อกอิน',
	['封锁时间']: 'เวลาที่ปิดกั้น',
	['锁的持续时间，时间到了会自动解除']: 'ระยะเวลาของการปิดกั้น เมื่อถึงเวลาจะยกเลิกโดยอัตโนมัติ',
	['查询IP白名单']: 'ค้นหา IP บัญชีขาว',
	['删除失败']: 'การลบล้มเหลว',
	['修改失败']: 'แก้ไขล้มเหลว',
	['拼图验证失败次数过多']: 'การตรวจสอบจิกซอว์ล้มเหลวมากเกินไป',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{-name}} ปฎิเสธที่จะร่วมงานกันเมื่อ {{-time}}',
	['储存过滤模組成功']: 'บันทึกตัวกรองโมดูลสำเร็จ',
	['删除过滤模組成功']: 'ลบตัวกรองโมดูลสำเร็จ',
	['解除谷歌验证成功']: 'ยกเลิกการตรวจสอบ Google สำเร็จ',
	['确定禁用平台?']: 'แน่ใจหรือว่าจะปิดใช้แพลตฟอร์ม',
	['确定启用平台?']: 'แน่ใจหรือว่าจะเปิดใช้แพลตฟอร์ม',
	['IP管理(客户端)']: 'จัดการ IP (ไคลเอ็นต์)',
	['上传']: 'อัพโหลด',
	['此栏位的时间会使用于报表的团队筛选']: 'เวลาของแถบนี้จะถูกใช้ในการคัดกรองทีมของฝ่ายรายงาน',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'เลือกทีม : กรองข้อมูลตัวเลขในช่วงเวลาของสถิติทีมของพนักงานฝ่ายบริการ',
	['备注最多{{inputLimit}}个字']: 'มีอักขระในหมายเหตุได้สูงสุด{{inputLimit}}ตัว',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{-inviter}} ได้โอนการสนทนาจาก {{-from}} ไปยัง {{-invitee}}ใน {{-time}}',
	['小时']: 'ชั่วโมง',
	['日']: 'วัน',
	['会员IP：{{ip}} 已加入前台黑名单']: 'IPสมาชิก : {{ip}} ได้ถูกเพิ่มเข้าไปในบัญชีดำfront-end',
	['新增失败']: 'การเพิ่มล้มเหลว',
	['会员IP被加入黑名单']: 'IP สมาชิกถูกเพิ่มในบัญชีดำ',
	['登入/接待时间']: 'เวลาล็อกอิน/ต้อนรับ',
	['timePeriodTooltipMessage']: 'ตัวกรองระยะเวลาสามารถกรองได้เฉพาะเวลาไม่สามารถกรองวันที่ได้ หากตั้งค่าเวลาสถิติทีมเป็นว้นถัดไป วันที่จะไม่เปลี่ยนตาม \nเช่น :\nตั้งค่าเวลาสถิติทีม 23:00-07:30\nค้นหา 1/9 00:00-23:59\nเวลากรอง 02:00-03:00\nข้อมูล 1/9 หลังคัดกรองคือ 02:00-03:00 \nผลลัพธ์ของข้อมูลนี้ไม่ตัดกับ 1/9 สถิติทีม (1/9 23:00- 2/9 07:30) ดังนั้นข้อมูลจะเป็น 0',
	['平均接待时间']: 'เวลาเฉลี่ยในการต้อนรับ',
	['平均登入时间']: 'เวลาเฉลี่ยในการล็อกอิน',
	['接待时间报表']: 'รายงานเวลาต้อนรับ',
	['登入时间报表']: 'รายงานเวลาล็อกอิน',
	['未登入']: 'ไม่ได้ล็อกอิน',
	['设定报表']: 'ตั้งค่ารายงาน',
	['设定对话是否记入报表中']: 'กำหนดว่าบทสนทนาจะถูกบันทึกไว้ในรายงานหรือไม่',
	['平均通话时长报表']: 'รายงานระยะเวลาโดยเฉลี่ยของการโทร',
	['平均通话数报表']: 'รายงานจำนวนสายโดยเฉลี่ย',
	['平均等待时间报表']: 'รายงานเวลาเฉลี่ยในการรอคิว',
	['客户满意度报表']: 'รายงานความพึงพอใจของลูกค้า',
	['平均回覆时间报表']: 'รายงานเวลาเฉลี่ยในการตอบกลับ',
	['调整原因']: 'สาเหตุการปรับเปลี่ยน',
	['请输入调整原因']: 'โปรดกรอกสาเหตุการปรับเปลี่ยน',
	['调整原因不可为空']: 'สาเหตุในการปรับเปลี่ยนห้ามเว้นว่าง',
	['日期时间']: 'เวลาวันที่',
	['操作人']: 'ผู้ปฏิบัติการ',
	['原因']: 'สาเหตุ',
	['更多']: 'เพิ่มเติม',
	['收回']: 'เรียกคืน',
	['设定报表成功']: 'ตั้งค่ารายงานสำเร็จ',
	['平均回覆时间']: 'เวลาเฉลี่ยในการตอบกลับ',
	['客服平均回覆时间']: 'เวลาเฉลี่ยในการตอบกลับของฝ่ายบริการลูกค้า',
	['客户回头率']: 'อัตราการกลับมาของลูกค้า',
	['客户ID']: 'ID ไคลเอ็นต์',
	['客服帐号']: 'บัญชีฝ่ายบริการลูกค้า',
	['小时回头率']: 'อัตราชั่วโมงการกลับมา',
	['日回头率']: 'อัตราวันการกลับมา',
	['遗漏时间']: 'เวลาที่หายไป',
	['请选择遗漏时间']: 'กรุณาเลือกเวลาที่หายไป',
	['平均遗漏时间']: 'เวลาที่หายไปโดยเฉลี่ย',
	['1分钟']: '1นาที',
	['2分钟']: '2นาที',
	['3分钟']: '3นาที',
	['4分钟']: '4นาที',
	['5分钟']: '5นาที',
	['离开时间']: 'เวลาที่ออก',
	['客户回头率报表']: 'รายงานอัตราการกลับมาฝ่ายบริการลูกค้า',
	['平台报表']: 'รายงานแพลตฟอร์ม',
	['对话总量']: 'จำนวนการสนทนาทั้งหมด',
	['接待总量']: 'จำนวนการต้อนรับทั้งหมด',
	['遗漏总量']: 'จำนวนที่หายไปทั้งหมด',
	['智能客服总量']: 'จำนวนบริการลูกค้าอัจฉริยะทั้งหมด',
	['智能转客服总量']: 'จำนวนที่อัจริยะโอนไปฝ่ายบริการลูกค้าทั้งหมด',
	['最后更新时间']: 'เวลาอัพเดตล่าสุด',
	['客服人数']: 'จำนวนคนที่บริการลูกค้า',
	['在线客服总数']: 'จำนวนบริการลูกค้าออนไลน์ทั้งหมด',
	['等待服务']: 'รอรับบริการ',
	['正在服务']: 'กำลังให้บริการ',
	['智能未转客服总量']: 'จำนวนที่อัจริยะไม่ได้โอนไปฝ่ายบริการลูกค้าทั้งหมด',
	['使用平台']: 'ใช้งานแพลตฟอร์ม',
	['泰文名称']: 'ชื่อภาษาไทย',
	['请输入泰文名称']: 'โปรดกรอกชื่อภาษาไทย',
	['英文名称']: 'ชื่อภาษาอังกฤษ',
	['请输入英文名称']: 'โปรดกรอกชื่อภาษาอังกฤษ',
	['中文名称']: 'ชื่อภาษาจีน',
	['请输入中文名称']: 'โปรดกรอกชื่อภาษาจีน',
	['若无需翻译请填写中文']: 'กรุณาเขียนภาษาจีนหากไม่ต้องการแปล',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'รายงานข้อมูลตัวเลขของบัญชีทั้งหมดจะถูกลบพร้อมกับบัญชีดังกล่าว ยืนยันที่จะลบใช่หรือไม่',
	['停用']: 'ปิดใช้งาน',
	['停用帐号']: 'หยุดใช้งานบัญชี',
	['通话总数']: 'บทสนทนาทั้งหมด',
	['等待中人数：{{pendingConversationCount}} 人']: 'กำลังรอ ：{{pendingConversationCount}} คน',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'รายงานกําลังถูกส่งออก โปรดไปที่หน้า"รายงานดาวน์โหลด"เพื่อดูความคืบหน้าและดาวน์โหลด',
	['汇出Load Data']: 'ส่งออกLoad Data',
	['报表下载']: 'ดาวน์โหลดรายงาน',
	['全平台']: 'แพลตฟอร์มทั้งหมด',
	['报表类型']: 'ประเภทรายงาน',
	['数据范围']: 'ขอบเขตข้อมูลตัวเลข',
	['汇出时间']: 'เวลาส่งออก',
	['完成时间']: 'เวลาเสร็จสิ้น',
	['申请者']: 'ผู้ยื่น',
	['下载']: 'ดาวน์โหลด',
	['重新汇出']: 'ส่งออกใหม่อีกครั้ง',
	['处理中']: 'กำลังดำเนินการ',
	['已完成']: 'เสร็จสิ้น',
	['失败']: 'ล้มเหลว',
	['下载成功']: 'ดาวน์โหลดสำเร็จ',
	['历史对话纪录']: 'ประวัติบันทึกการสนทนา',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'การเชื่อมต่อขัดข้อง กรุณากด "ตกลง" เพื่อเชื่อมต่อใหม่ หากไม่สำเร็จ ระบบจะจบการสนทนา',
	['引用功能管理']: 'จัดการฟังก์ชันอ้างอิง',
	['引用对话']: 'สนทนาอ้างอิง',
	['设定引用对话成功']: 'ตั้งค่าสนทนาอ้างอิงสำเร็จ',
	['客户管理']: 'จัดการลูกค้า',
	['重要客户帐号']: 'บัญชีลูกค้าสำคัญ',
	['请输入重要客户帐号、备注等关键字']: 'กรุณากรอกคีย์เวิร์ดบัญชีลูกค้าสำคัญหรือหมายเหตุเป็นต้น',
	['新增重要客户']: 'เพิ่มบัญชีลูกค้าสำคัญ',
	['重要客户帐号不能为空']: 'บัญชีลูกค้าสำคัญห้ามเว้นว่าง',
	['输入多个帐号请用, 区隔']: 'กรุณาใช้ , ในการกรอกหลายบัญชี',
	['修改重要客户']: 'แก้ไขบัญชีสำคัญ',
	['重要帐号']: 'บัญชีลูกค้าสำคัญ',
	['会员类型']: 'ประเภทสมาชิก',
	['引用']: 'อ้างอิง',
	['收回(訊息)']: 'เรียกคืน',
	['收回功能管理']: 'จัดการฟังก์ชันเรียกคืน',
	['收回提示文字不能为空']: 'ข้อความเตือนที่เรียกคืนห้ามเว้นว่าง',
	['收回对话']: 'เรียกคืนการสนทนา',
	['收回提示文字（中文）']: 'ข้อความเตือนที่เรียกคืน (จีน)',
	['收回提示文字（英文）']: 'ข้อความเตือนที่เรียกคืน (อังกฤษ)',
	['收回提示文字（泰文）']: 'ข้อความเตือนที่เรียกคืน (ไทย)',
	['视频']: 'วีดิโอ',
	['确定要收回讯息吗？']: 'ยืนยันที่จะเรียกคืนข้อความหรือไม่',
	['设定收回功能成功']: 'ตั้งค่าฟังก์ชันเรียกคืนสำเร็จ',
	['遗漏数据']: 'ข้อมูลตัวเลขที่หายไป',
	['全选']: 'เลือกทั้งหมด',
	['请选择使用平台']: 'โปรดเลือกแพลตฟอร์มที่ใช้',
	['日期计算方式']: 'วิธีคำนวณวันที่',
	['以会员进入正在服务区的时间计算']: 'คํานวณจากเวลาที่สมาชิกเข้าสู่พื้นที่กำลังให้บริการ',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'คํานวณจากเวลาที่สมาชิกเข้าสู่พื้นที่รอให้บริการ หากคลิกบริการลูกค้าอัจฉริยะแล้วไม่ได้เข้าสู่พื้นที่รอให้บริการ จะคำนวณเวลาจากการคลิกบริการลูกค้าอัจฉริยะ',
	['以会员进入等待服务区的时间计算']: 'คํานวณจากเวลาที่สมาชิกเข้าสู่พื้นที่รอให้บริการ',
	['以客服接通对话的时间进行计算']: 'คำนวณจากเวลาที่บริการลูกค้ารับสายสนทนา',
	['以会员进入等待服务区的时间进行计算']: 'คํานวณจากเวลาที่สมาชิกเข้าสู่พื้นที่รอให้บริการ',
	['以会员点击智能客服的时间计算']: 'คำนวณจากเวลาที่สมาชิกได้คลิกบริการลูกค้าอัจฉริยะ',
	['相同类型才会计算回头']: 'ประเภทเดี๋ยวกันจะคำนวณการกลับมา',
	['登入联系离开后再次登入联系']: 'เข้าสู่ระบบออกจากการสื่อสารและเข้าสู่',
	['一通对话只会触发一次回头次数']: 'หนึ่งการสนทนาจะเรียกใช้จํานวนการกลับมาได้เพียงครั้งเดียว',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'ในเวลาที่สมาชิกเดียวกันติดต่อต่อเนื่อง3ครั้ง คำนวณเป็นการกลับมา1ครั้งในแต่ละการสนทนาของฝ่ายบริการลูกค้าสองสายแรก',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'สัดส่วนสนทนาที่มีผลจากการติดต่อซ้ำหลังจากสมาชิกเดียวกันจบการสนทนาภายใน{{-hour}}ชั่วโมงในแต่ละวัน',
	['未登入联系离开后再次未登入联系']: 'ติดต่อโดยไม่เข้าสู่ระบบอีกครั้งหลังจากออกจากการติดต่อโดยไม่เข้าสู่ระบบ',
	['请输入重要客户帐号']: 'กรุณากรอกหมายเลขบัญชีลูกค้าสำคัญ',
	['开始日期']: 'วันที่เริ่มต้น',
	['结束日期']: 'วันที่เริ่มต้น',
	['标签名称/数量']: 'ชื่อเท็ก/จำนวน',
	['暂无数据']: 'ไม่มีข้อมูลในขณะนี้',
	['AI客服设定']: 'ตั้งค่าเจ้าหน้าที่บริการลูกค้า AI',
	['AI共同设定']: 'ตั้งค่า AI ร่วม',
	['平台AI设定']: 'ตั้งค่า AI แพลตฟอร์ม',
	['平台 AI SKILL 设定']: 'ตั้งค่า AI SKILL แพลตฟอร์ม',
	['指令输入说明']: 'ป้อนอธิบายคำสั่ง',
	['输入文字档']: 'ป้อนไฟล์ข้อความ',
	['不需要区分功能']: 'ไม่จำเป็นต้องแบ่งพื้นที่ฟังก์ชัน',
	['套用平台']: 'ใช้กับแพลตฟอร์ม',
	['请输入指令']: 'กรุณาป้อนคำสั่ง',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'การสนทนาระหว่าง AI กับสมาชิกเกิน <<inputNumber>> รอบต้องแจ้งเจ้าหน้าที่บริการลูกค้า',
	['指令']: 'คำสั่ง',
	['AI开关']: 'เปิดปิด AI',
	['AI客服名称']: 'ชื่อเจ้าหน้าที่บริการลูกค้า AI',
	['AI客服名称不能为空']: 'ชื่อเจ้าหน้าที่บริการลูกค้า AI ห้ามเว้นว่าง',
	['请输入AI客服名称']: 'กรุณากรอกชื่อเจ้าหน้าที่บริการ AI',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'ยืนยันที่จะปิดการบริการ AI หรือไม่ หลังจากปิดจะไม่สามารถเปิดใช้งานบริการ AI ได้อีกครั้ง',
	['侦测到对话有异常状态，请尽快处理']: 'ตรวจพบสถานะการสนทนาผิดปกติ กรุณาดำเนินการโดยเร็วที่สุด',
	['需要转接人工客服，请尽快处理']: 'ต้องการโอนสายไปยังเจ้าหน้าที่',
	['总平均通话时长']: 'ระยะเวลาการสนทนาโดยเฉลี่ยทั้งหมด',
	['AI平均通话时长']: 'ระยะเวลาการสนทนาAIโดยเฉลี่ย',
	['人工平均通话时长']: 'ระยะเวลาการสนทนามนุษย์โดยเฉลี่ย',
	['每日总平均']: 'ค่าเฉลี่ยต่อวันทั้งหมด',
	['AI日平均']: 'ค่าเฉลี่ย AI ต่อวัน',
	['人工日平均']: 'ค่าเฉลี่ยมนุษย์ต่อวัน',
	['通话总量']: 'จำนวนการสนทนาทั้งหมด',
	['AI通话总量']: 'จำนวนการสนทนาAIทั้งหมด',
	['共同']: 'ร่วม',
	['总计']: 'ทั้งหมด',
	['总计请勿超过{{limit}}字']: 'ความยาวรวมไม่ควรเกิน {{-limit}} คำ',
	['总平均回覆时间']: 'เวลาโดยเฉลี่ยการตอบสนทนาทั้งหมด',
	['AI平均回覆时间']: 'เวลาโดยเฉลี่ยการตอบสนทนาด้วย AI ทั้งหมด',
	['人工平均回覆时间']: 'เวลาโดยเฉลี่ยการตอบสนทนาด้วยมนุษย์ทั้งหมด',
	['AI日总量']: 'จำนวนAIทั้งหมดต่อวัน',
	['人工日总量']: 'จำนวนดำเนินการโดยมนุษย์ทั้งหมดต่อวัน',
	['指令不能为空']: 'คำสั่งห้ามเว้นว่าง',
	['{{name}} 已于 {{time}} 开启AI']: '{{-name}} เปิด AI ในเวลา {{-time}}',
	['{{name}} 已于 {{time}} 关闭AI']: '{{-name}} ปิด AI ในเวลา {{-time}}',
	['人机合作日总量']: 'จำนวนวันความร่วมมือระหว่างคนและเครื่องจักร',
	['人工通话总量']: 'จำนวนการสนทนาโดยมนุษย์ทั้งหมด',
	['人机合作通话总量']: 'จำนวนร่วมมือการสนทนาระหว่างคนและเครื่องจักร',
	['以对话建立时间计算']: 'คำนวณจากเวลาที่สร้างการสนทนา',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'ตรวจพบสถานะการสนทนาผิดปกติ - จำนวนการสนทนาเกินขีดจำกัด',
	['侦测到对话有异常状态 - 系统发生错误']: 'ตรวจพบสถานะการสนทนาผิดปกติ - ระบบเกิดข้อผิดพลาด',
	['人机合作-人工日平均']: 'ร่วมมือระหว่างคนเครื่องจักร-ค่าโดยเฉลี่ยรายวันแรงงานคน',
	['人机合作-AI日平均']: 'ร่วมมือระหว่างคนเครื่องจักร-ค่าโดยเฉลี่ยรายวัน AI',
	['人机合作-人工平均通话时长']: 'ร่วมมือระหว่างคนเครื่องจักร-ระยะเวลาสนทนาโดยเฉลี่ยของแรงงานคน',
	['人机合作-AI平均通话时长']: 'ร่วมมือระหว่างคนเครื่องจักร-ระยะเวลาสนทนาโดยเฉลี่ยของ AI',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'ตรวจพบสถานะการสนทนาผิดปกติ - รอ AI API เกิน 2 นาที',
	['侦测到对话有异常状态 - AI 发生错误']: 'ตรวจพบสถานะการสนทนาผิดปกติ - เกิดข้อผิดพลาดที่ AI',
	['侦测到对话有异常状态 - AI 没有回复']: 'ตรวจพบสถานะการสนทนาผิดปกติ - ไม่มีการตอบกลับจาก AI',
	['数据']: 'ข้อมูล',
	['指令不能超过{{limit}}字']: 'คำสั่งต้องไม่เกิน {{-limit}} คำ',
	['数据不能为空']: 'ข้อมูลห้ามว่างเปล่า',
	['数据不能超过100万字']: 'คำสั้งห้ามเกิน 1 ล้านคำ',
	['需{{limit}}字以内']: 'ต้องมีไม่เกิน {{-limit}} คำ',
	['数据输入说明']: 'คําแนะนําในการป้อนข้อมูล',
	['需100万字以内']: 'ต้องน้อยกว่า 1 ล้านคํา',
	['至少要有一组 ~~~~~ 与 =====']: 'ต้องมีอย่างน้อยหนึ่งชุดของ ~~~~~ และ =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'ตัวคั่น ~~~~~ และ ===== ต้องปรากฏเป็นคู่',
	['需以 ===== 结尾']: 'ต้องลงท้ายด้วย =====',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'ใส่เครื่องหมาย ~ 5 ตัวในบรรทัดใต้หัวข้อ โดยด้านหน้าและด้านหลังต้องไม่มีข้อความหรือช่องว่างอื่น',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'ใส่เครื่องหมาย = 5 ตัวในบรรทัดใต้เนื้อหา โดยด้านหน้าและด้านหลังต้องไม่มีข้อความหรือช่องว่างอื่น',
	['范例']: 'ตัวอย่าง',
	['标题A（可多行）']: 'หัวข้อ A (มีได้หลายบรรทัด)',
	['内容A（可多行，可含任何文字）']: 'เนื้อหา A (หลายบรรทัด มีข้อความใดก็ได้)',
	['标题B（可多行）']: 'หัวข้อ B (มีได้หลายบรรทัด)',
	['内容B（可多行，可含任何文字）']: 'เนื้อหา B (หลายบรรทัด มีข้อความใดก็ได้)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'ลำดับโมเดล (โมเดลด้านบนจะถูกใช้ก่อน หากใช้งานไม่ได้จะสลับไปโมเดลถัดไปโดยอัตโนมัติ)',
	['主要']: 'หลัก',
	['备援{{index}}']: 'สำรอง {{index}}',
	['新增备援模型']: 'เพิ่มโมเดลสำรอง',
	['请输入数据']: 'กรุณากรอกข้อมูล',
	['正在转接中...']: 'กำลังเชื่อมต่อ',
	['（中文）']: '(ภาษาจีน)',
	['（英文）']: '(ภาษาอังกฤษ)',
	['（泰文）']: '(ภาษาไทย)',
	['（越南文）']: '(ภาษาเวียดนาม)',
	['越南文名称']: 'ชื่อภาษาเวียดนาม',
	['请输入越南文名称']: 'กรุณากรอกชื่อเวียดนาม',
	['模式']: 'โหมด',
	['越南语']: 'ภาษาเวียดนาม',
	['IP白名单设定']: 'การตั้งค่ารายการที่อนุญาตพิเศษของที่อยู่ IP',
	['建立时间']: 'ตั้งค่าเวลา',
	['批次删除']: 'ทำการลบเป็นบ้างครั้ง',
	['请确认是否删除 IP 白名单？']: 'โปรดยืนยันว่าจะลบรายการที่อนุญาตพิเศษของ IP หรือไม่',
	['开启快捷选单']: 'เปิดเมนูลัด',
	['收合快捷选单']: 'ปิดเมนูลัด',
	['是否有收回人员讯息']: 'ทำการเก็บข้อความ AI หรือไม่',
	['是否有收回AI讯息']: 'ทำการเก็บข้อความ AI หรือไม่',
	['消息已被客服撤回']: 'ฝ่ายบริการลูกค้าถอนข้อความแล้ว',
	['用户快捷选单管理']: 'การจัดการเมนูทางลัดของผู้ใช้',
	['电脑预览']: 'ตัวอย่างแสดงบนพีซี',
	['手机预览']: 'ตัวอย่างแสดงบนมือถือ',
	['档案格式：PNG、JPG、JPEG']: 'รูปแบบไฟล์: PNG, JPG, JPEG',
	['请选择上传档案']: 'กรุณาเลือก อัพโหลดไฟล์',
	['新增快捷成功']: 'เพิ่มเมนูทางรัดสําเร็จ',
	['修改快捷成功']: 'แก้ไขเมนูทางรัดสําเร็จ',
	['设定快捷选单成功']: 'ตั้งค่าเมนูทางรัดสําเร็จ',
	['删除快捷成功']: 'ลบเมนูทางรัดสําเร็จ',
	['确定删除此快捷？']: 'ยีนยันทำการ ลบเมนูทางรัดหรือไม่',
	['新增内容']: 'เพิ่มเนื้อหา',
	['选项內容']: 'ตัวเลือกเนื้อหา',
	['{{itemLabel}}內容不能为空']: 'เนื้อหา {{-itemLabel}} ห้ามว่างเปล่า',
	['请输入{{itemLabel}}标题']: 'โปรดตั้งชื่อ {{-itemLabel}}',
	['请输入{{itemLabel}}选项']: 'โปรดป้อนตัวเลือก {{-itemLabel}}',
	['{{text}}不可为空']: '{{-text}} ห้ามว่างเปล่า',
	['显示更多']: 'แสดงเพิ่มเติม',
	['公告标签']: 'ป้ายประกาศ',
	['请选择公告标签']: 'กรุณาเลือกป้ายประกาศ',
	['{{text}}标题']: '{{-text}}ชื่อเรื่อง',
	['{{text}}內文']: '{{-text}}เนื้อหา',
	['{{text}}最多{{inputLimit}}个字']: '{{-text}}ไม่เกิน{{inputLimit}}ตัวอักษร',
	['公告内文档案大小总计不得大于10MB']: 'ขนาดรวมของไฟล์เอกสารในประกาศต้องไม่เกิน 10MB',
	['用户尚未离开，确认要完成对话？']: 'ผู้ใช้ยังไม่ออกไป ยืนยันว่าต้องการสนทนาให้เสร็จสิ้นหรือไม่?',
	['{{name}} 已于 {{time}} 离开对话']: '{{-name}} ออกจากการสนทนาใน {{-time}}',
	['客服人员']: 'บริการลูกค้า',
	['*新增多个IP请使用逗号「 , 」隔开']: '* หากเพิ่ม IP หลายตัว โปรดใช้เครื่องหมายจุลภาค 「,」เพื่อแยกรายการ',
	['是否新增IP白名单？']: 'เพิ่ม IP Whitelist ใหม่หรือไม่?',
	['IP已存在']: 'มี IP อยู่แล้ว',
	['监控区管理']: 'การจัดการพื้นที่ตรวจสอบ',
	['监控区开关']: 'สวิตช์เปิดปิดพื้นที่ตรวจสอบ',
	['设定监控区开关成功']: 'ตั้งค่าสวิตช์เปิดปิดพื้นที่ตรวจสอบสำเร็จ',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'เมื่อเปิดใช้งานฟังก์ชัน จะมีแท็บ [พื้นที่ตรวจสอบ] เพิ่มขึ้นในพื้นที่รอให้บริการ ซึ่งจะแสดงบทสนทนาที่ถูก AI สกัดกั้นทั้งแพลตฟอร์มและบทสนทนา 5 รายการที่ยังไม่ได้อ่านนานที่สุด สามารถคลิกเพื่อข้ามไปยังบทสนทนาที่เกี่ยวข้องได้อย่างรวดเร็ว',
	['{{name}} 新增了标签 {{tag}}']: '{{-name}} เพิ่มแท็กใหม่ {{-tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{-name}} ลบแท็กออก {{-tag}}',
	['状态切换为暂离']: 'สถานะเปลี่ยนเป็นออกชั่วคร่าว',
	['状态切换为工作中']: 'สถานะเปลี่ยนเป็นทำงาน',
	['监控区']: 'พื้นที่ตรวจสอบ',
	['自动接线管理']: 'เชื่อมต่อการจัดการอัตโนมัติ',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'เมื่อจำนวนการรับของเจ้าหน้าที่บริการลูกค้าบนแพลตฟอร์มทั้งหมดถึงขีดจำกัดแล้ว ระบบจะไม่เชื่อมต่อการสนทนาเข้าสู่เขตรอรับบริการโดยอัตโนมัติ แต่เจ้าหน้าที่บริการลูกค้าสามารถรับการสนทนาได้ โดยไม่จำกัดจำนวนด้วยตนเอง',
	['自动接线数量上限']: 'ขีดจำกัดจำนวนการเชื่อมต่ออัตโนมัติ',
	['设定自动接线成功']: 'ตั้งค่าเชื่อมต่อสายอัตโนมัติสำเร็จ',
	['{{name}} 进线']: '{{-name}} สายเรียกเข้า',
	['工作/暂离时间']: 'ทำงาน/ออกชั่วคร่าว',
	['工作时长报表']: 'รายงานเวลาทำงาน',
	['暂离时长报表']: 'รายงานเวลาขาดงานชั่วคราว',
	['平均工作时长']: 'ชั่วโมงการทำงานโดยเฉลี่ย',
	['平均暂离时长']: 'ระยะเวลาการขาดงานโดยเฉลี่ย',
	['关键字提醒']: 'การแจ้งเตือนโดยคีย์เวิร์ด',
	['客户发话']: 'ลูกค้ากำลังพิมพ์',
	['AI发话']: 'AI กำลังพิมพ์',
	['发话来源']: 'แหล่งที่มาของคำพูด',
	['请输入发话来源、关键字']: 'กรุณาระบุแหล่งที่มาของแชทและคีย์เวิร์ด',
	['新增关键字']: 'เพิ่มคีย์เวิร์ด',
	['修改关键字']: 'แก้ไขคีย์เวิร์ด',
	['新增关键字成功']: 'เพิ่มคีย์เวิร์ดสำเร็จ',
	['修改关键字成功']: 'แก้ไขคีย์เวิร์ดสำเร็จ',
	['删除关键字成功']: 'ลบคีย์เวิร์ดสำเร็จ',
	['是否删除此关键字？']: 'ทำการลบคีย์เวิร์ด หรือไม่',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'กรุณาใช้ 「；」เพื่อแยกคีย์เวิร์ดที่แตกต่างกันต้องมีความยาวไม่เกิน 100 ตัวอักษร',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'ลูกค้าได้ใช้คีย์เวิร์ด [{{-word}}] โปรดให้เจ้าหน้าที่บริการลูกค้าให้ความสนใจเป็นอย่างยิ่ง',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI ได้ใช้คีย์เวิร์ด [{{-word}}] โปรดให้เจ้าหน้าที่บริการลูกค้าให้ความสนใจเป็นอย่างยิ่ง',
	['请输入通知时间']: 'กรุณากรอกเวลาแจ้งเตือน',
	['自动接线开关']: 'สวิตช์เปิด-ปิด เชื่อมต่ออัตโนมัติ',
	['自动接线数量上限不可为空']: 'การกำหนดจำนวนสูงสุดของการเชื่อมต่ออัตโนมัติไม่สามารถเว้นว่างได้',
	['请输入数量上限']: 'กรุณากรอกจำนวนสูงสุด',
	['离开状态侦测开关']: 'ออกจากตรวจจับสถานะเปิด-ปิด',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'เมื่อเปิดใช้งานแล้ว หากเจ้าหน้าที่บริการลูกค้าอยู่ในสถานะการทำงานสุดท้ายบนแพลตฟอร์มหรือยังมีการให้บริการลูกค้า โดยยังไม่ได้ให้บริการผู้อื่น จะไม่สามารถออกจากระบบได้',
	['离开时间通知开关']: 'สวิตช์เปิด-ปิด แจ้งเตือนเวลาออกจากระบบ',
	['通知时间不可重复']: 'เวลาแจ้งเตือนไม่สามารถทำซ้ำได้',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'ตรวจจับเวลาที่บัญชี CS ออกจากระบบ เมื่อเวลาที่ออกจากระบบถึงเวลาที่กำหนด จะแจ้งเตือนบัญชีที่มีสิทธิ์ระดับผู้จัดการขึ้นไป รวมถึงบัญชี CS ที่เป็นผู้ทำให้เกิดการออกจากระบบด้วย',
	['最后暂离时间报表']: 'รายงานเวลาการออกชั่วคราวล่าสุด',
	['平均最后暂离时间']: 'เวลาออกเดินทางชั่วคราวครั้งสุดท้ายโดยเฉลี่ย',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{-name}} ออกจากระบบไปแล้วเป็นเวลา [{{minute}}] นาที!',
	['历史对话记录下载']: 'ดาวน์โหลดประวัติการสนทนา',
	['使用模式']: 'โหมดการใช้งาน',
	['标准模式']: 'โหมดมาตรฐาน',
	['ID模式']: 'รูปแบบ ID',
	['即进模式']: 'โหมดเข้าสู่ทันที',
	['复制即进网址']: 'คัดลอกและป้อน URL',
	['生成新网址']: 'สร้าง URL ใหม่',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'จำเป็นต้องให้ข้อมูลโปรไฟล์ลูกค้าในรูปแบบมาตรฐาน ซึ่งเป็นโหมดที่ระบบกำหนดไว้ล่วงหน้า',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'ใส่รหัส ID เพื่อเข้าสู่ระบบบริการลูกค้า โดยไม่จำเป็นต้องให้ข้อมูลโปรไฟล์ลูกค้า',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'ผ่านลิงก์เข้าสู่ระบบทันที สามารถเข้าสู่ระบบบริการลูกค้าได้โดยตรง โดยไม่ต้องให้ข้อมูล ระบบจะกำหนดชื่อแขกแบบสุ่มโดยอัตโนมัติ',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'กรุณายืนยันอีกครั้งว่าต้องการเปลี่ยนจาก [<<prevTypeText>>] เป็น [<<nextTypeText>>]',
	['以下是即进网址']: 'ลิงก์เข้าสู่ระบบทันทีมีดังต่อไปนี้',
	['复制网址']: 'คัดลอก URL',
	['使用模式切换成功']: 'เปลี่ยนโหมดการใช้งานสำเร็จ',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'กรุณายืนยันอีกครั้งว่าต้องการเปลี่ยนลิงก์หรือไม่ หากเปลี่ยนแล้ว <<redText>>',
	['当前即进网址']: 'ลิงก์เข้าสู่ระบบทันทีปัจจุบัน',
	['新即进网址']: 'ลิงก์เข้าสู่ระบบทันทีอันใหม่',
	['复制即进网址成功']: 'คัดลอกลิงก์เข้าสู่ระบบทันทีสำเร็จ',
	['报表统计']: 'รายงานสถิติ',
	['操作時間']: 'เวลาทำการ',
	['统计类型']: 'ประเภทสถิติ',
	['请选择统计类型']: 'โปรดเลือกประเภทสถิติ',
	['查询参数']: 'ค้นหาพารามิเตอร์',
	['申请时间']: 'เวลาสมัคร',
	['产出时间']: 'เวลา output',
	['申请帐号']: 'สมัครบัญชี',
	['详细资料']: 'รายละเอียด',
	['重新执行统计']: 'ดำเนินการสถิติอีกครั้ง',
	['执行统计']: 'ดำเนินการสถิติ',
	['登入时间范围']: 'ช่วงเวลาการเข้าสู่ระบบ',
	['选择团队：筛选出该团队所有客服人员']: 'เลือกทีม: คัดกรองพนักงานบริการลูกค้าทั้งหมดของทีมนี้',
	['API接收日志']: 'API รับบันทึก',
	['新增来源']: 'เพิ่มแหล่งที่มา',
	['CS']: 'CS',
	['包网']: 'การเข้าพนันบอล',
	['包网API']: 'แพ็กเกจ API',
	['第 {{min}} - {{max}} 笔']: 'เลขที่ {{min}} - {{max}} ครั้ง',
	['选择的日期区间需小于等于{{limit}}天']: 'ช่วงวันที่เลือกต้องน้อยกว่าหรือเท่ากับ{{limit}}วัน',
	['请选择日期时间查询条件']: 'กรุณาเลือกเงื่อนไขวันที่และเวลา',
	['类型']: 'ประเภท',
	['公司']: 'บริษัท',
	['请输入公司']: 'กรุณาใส่ชื่อบริษัท',
	['会员帐号']: 'บัญชีสมาชิก',
	['请输入会员帐号']: 'กรุณาใส่บัญชีสมาชิก',
	['是否查看详细资料？']: 'คุณต้องการดูรายละเอียดไหม?',
	['传送资料']: 'ส่งข้อมูล',
	['CS回覆资料']: 'ข้อมูลการตอบกลับ CS',
	['内容']: 'เนื้อหา',
	['请选择进入的公司']: 'กรุณาเลือกบริษัทที่ต้องการเข้าสู่ระบบ',
	['指令数据更新纪录']: 'บันทึกการอัปเดตข้อมูลคำสั่ง',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. ระบบการจัดอันดับ: คำสั่งของบริษัททั้งหมดจะถูกจัดเรียงร่วมกันเพื่อให้ระบบทำงานอย่างมีประสิทธิภาพ。',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. การแยกข้อมูล: ผู้ใช้งานสามารถดูบันทึกการอัปเดตของบริษัทตนเองได้เท่านั้น ไม่สามารถดูบันทึกของบริษัทอื่นได้。',
	['微调训练']: 'การปรับแต่งการฝึกอบรม',
	['执行微调']: 'ปรับแต่ง',
	['操作帐号']: 'การจัดการบัญชี',
	['是否修改AI API?']: 'มีการเปลี่ยนแปลง API ของ AI หรือไม่?',
	['保存设置']: 'บันทึกการตั้งค่า',
	['修改AI API成功']: 'แก้ไข AI API สำเร็จ',
	['请输入{{text}}']: 'กรุณาใส่{{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}}ห้ามเกิน{{limit}}ตัวอักษร',
	['AI API']: 'เอไอ API',
	['微调训练记录']: 'บันทึกการฝึกอบรมแบบปรับแต่ง',
	['模型名称']: 'ชื่อโมเดล',
	['新增文本']: 'เพิ่มข้อความ',
	['修改文本']: 'ปรับข้อความ',
	['请输入名称']: 'กรุณาใส่ชื่อ',
	['取消修改微调文本']: 'ยกเลิกการปรับแต่งข้อความ',
	['角色不可为空']: 'ตัวละครไม่สามารถว่างเปล่าได้',
	['请选择角色']: 'กรุณาเลือกตัวละคร',
	['内容不可为空']: 'เนื้อหาห้ามว่าง',
	['请输入内容']: 'กรุณาใส่เนื้อหา',
	['系统']: 'ระบบ',
	['会员']: 'สมาชิก',
	['AI']: 'ปัญญาประดิษฐ์',
	['请确认是否取消？']: 'กรุณายืนยันว่าจะยกเลิกหรือไม่？',
	['新增微调文本成功']: 'เพิ่มข้อความการปรับแต่งสำเร็จ',
	['修改微调文本成功']: 'การแก้ไขข้อความสำเร็จ',
	['自定模型名称']: 'ตั้งชื่อโมเดลเอง',
	['微调确认讯息']: 'ปรับแต่งข้อความยืนยัน',
	['请确认是否执行微调训练？']: 'กรุณายืนยันว่าจะแก้ไขการฝึกอบรมหรือไม่?',
	['删除微调文本']: 'ลบบทความที่ปรับแต่ง',
	['请确认是否刪除？']: 'กรุณายืนยันว่าต้องการลบหรือไม่？',
	['刪除微调文本成功']: 'ลบการปรับแต่งข้อความสำเร็จ',
	['请输入模型名称']: 'กรุณาใส่ชื่อโมเดล',
	['执行微调成功']: 'การปรับแต่งสำเร็จ',
	['取消修改文本成功']: 'ยกเลิกการแก้ไขข้อความสำเร็จ',
	['取消新增文本成功']: 'การยกเลิกการเพิ่มข้อความสำเร็จ',
	['您已成功登出客服系统。']: 'คุณได้ออกจากระบบบริการลูกค้าเรียบร้อยแล้ว。',
	['如需重新登录，请返回包网！']: 'หากต้องการเข้าสู่ระบบอีกครั้ง โปรดกลับไปที่แพ็คเกจ！',
	['您已成功登出客服系统管理端。']: 'คุณได้ออกจากระบบการจัดการบริการลูกค้าเรียบร้อยแล้ว。',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'เมื่อ "เวลารอเฉลี่ย" แสดงเป็น 0 วินาที สาเหตุที่เป็นไปได้มีดังนี้：',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: 'เวลารอการสนทนาทั้งหมดในวันนั้นเป็น 0 วินาที (เช่น โดยอัตโนมัติหรือการตอบสนองทันที ไม่ต้องรอ)。',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2.ตามสูตร 「เวลารอรวมต่อวัน ÷ จำนวนการพูดคุยต่อวัน」 ผลลัพธ์ที่คำนวณได้จะปัดเศษเป็น 0 วินาที。',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'ระบบแสดงว่า "ยังไม่ได้เข้าสู่ระบบ" หมายความว่าบัญชีนี้ไม่ได้สร้างข้อมูลการสนทนาใด ๆ ในช่วงเวลาที่กำหนดของทีม',
	['加入微调']: 'เพิ่มการปรับแต่ง',
	['启用API Key']: 'เปิดใช้งาน API Key',
	['微调汇入对话记录']: 'ปรับแต่งการนำเข้าบันทึกการสนทนา',
	['对话数量']: 'จำนวนการสนทนา',
	['文本最后角色需为AI或客服人员']: 'ตัวละครสุดท้ายของข้อความควรเป็น AI หรือพนักงานบริการลูกค้า',
	['汇入微调文本']: 'นำเข้าข้อความการปรับแต่ง',
	['檔案格式：CSV，且档案大小不得大于']: 'รูปแบบไฟล์: CSV และขนาดไฟล์ต้องไม่เกิน',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'ตัวละครสุดท้ายของข้อความต้องเป็น AI หรือพนักงานบริการลูกค้า กรุณาแก้ไขก่อนส่งออกหรือปรับแต่งใหม่',
	['批量加入微调']: 'การเพิ่มการปรับแต่งเป็นกลุ่ม',
	['自定加入微调的名称']: 'ตั้งชื่อที่ปรับแต่งเอง',
	['微调名称']: 'ปรับชื่อ',
	['请输入微调的名称']: 'กรุณาใส่ชื่อการปรับแต่ง',
	['微调的名称']: 'ชื่อการปรับจูน',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'กรุณายืนยันว่าต้องการลบเป็นจำนวนมาก (ทั้งหมด {{selectedFineTuningRecordsLength}} รายการ)',
	['已取消']: 'ยกเลิก',
	['取消微调']: 'ยกเลิกการปรับจูน',
	['取消微调成功']: 'ยกเลิกการปรับแต่งสำเร็จ',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'การยกเลิกการฝึกฝนของระบบบริการลูกค้านี้ จะต้องยกเลิกการฝึกฝนแบบละเอียดของ OpenAI ในแบ็คเอนด์พร้อมกันด้วย เท่านั้นเมื่อทั้งสองอย่างถูกยกเลิก การฝึกฝนแบบละเอียดจึงจะถูกลบอย่างสมบูรณ์ โปรดยืนยันว่าคุณต้องการยกเลิกการฝึกฝนในระบบบริการลูกค้านี้หรือไม่?',
	['复制快捷语成功']: 'คัดลอกเสียงลัดสำเร็จ',
	['复制常用图片成功']: 'คัดลอกภาพที่ใช้บ่อยสำเร็จ',
	['左侧']: 'ด้านซ้าย',
	['右侧']: 'ด้านขวา',
	['{{text}}正在服务{{total}}则对话']: '{{text}}กำลังให้บริการ{{total}}การสนทนา',
	['新增跑马灯成功']: 'เพิ่มป้ายวิ่งสำเร็จ',
	['修改跑马灯成功']: 'แก้ไขป้ายวิ่งสำเร็จ',
	['刪除跑马灯成功']: 'ลบป้ายวิ่งสำเร็จ',
	['启用跑马灯成功']: 'เปิดใช้งานวิ่งไฟสําเร็จ',
	['停用跑马灯成功']: 'ปิดการทำงานป้ายวิ่งสำเร็จ',
	['对象栏位']: 'ช่องวัตถุ',
	['显示跑马灯内容']: 'แสดงเนื้อหาวิ่ง',
	['请确认是否启用跑马灯？']: 'กรุณายืนยันว่าจะเปิดใช้งานป้ายโฆษณาแบบวิ่งหรือไม่?',
	['请确认是否停用跑马灯？']: 'กรุณายืนยันว่าต้องการปิดการใช้งานโปรแกรมวิ่งหรือไม่?',
	['请确认是否删除跑马灯？']: 'กรุณายืนยันว่าต้องการลบรันนิ่งไลท์หรือไม่？',
	['{{text}}最多{{inputLimit}}组']: '{{text}}มากที่สุด{{inputLimit}}ชุด',
	['数值范围']: 'ช่วงค่าหมายเลข',
	['数值不能为空']: 'ค่าต้องไม่เป็นค่าว่าง',
	['数值']: 'ค่าตัวเลข',
	['请输入数字']: 'กรุณาใส่ตัวเลข',
	['输入多组文字请用, 区隔']: 'กรุณาใช้ , เพื่อแยกข้อความหลายชุด',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'เมื่อผู้ใช้ตรงตามชื่อที่กำหนดและเนื้อหาในกฎของช่อง จะเริ่มทำงานโปรโมทป้ายวิ่ง',
	['新增跑马灯']: 'เพิ่มตัววิ่ง',
	['对象栏位不能为空']: 'ช่องวัตถุไม่สามารถว่างเปล่าได้',
	['请输入对象栏位']: 'กรุณาใส่ช่องวัตถุ',
	['栏位规则']: 'กฎของคอลัมน์',
	['栏位规则不能为空']: 'กฎช่องไม่สามารถเป็นค่าว่างได้',
	['请选择栏位规则']: 'โปรดเลือกกฎช่องทาง',
	['开头图示']: 'ภาพเริ่มต้น',
	['开头图示不能为空']: 'รูปภาพเริ่มต้นไม่สามารถว่างเปล่าได้',
	['请选择开头图示']: 'กรุณาเลือกภาพเริ่มต้น',
	['跑马灯内容']: 'วิ่งไฟข้อความ',
	['修改跑马灯']: 'ปรับเปลี่ยนมุมมอง',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'การเปลี่ยนแปลงการตั้งค่าแพลตฟอร์มจะถูกนำไปใช้กับตัวละครระดับล่างหรือไม่ ยืนยันการแก้ไขหรือไม่?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'คุณแน่ใจหรือว่าต้องการลบภาพที่ใช้บ่อย[ส่วนตัว/สาธารณะ][{{title}}]?',
	['一经确认删除无法复原。']: 'เมื่อได้รับการยืนยันแล้ว การลบจะไม่สามารถฟื้นฟูกลับมาได้。',
	['客服日志']: 'บันทึกการบริการลูกค้า',
	['请输入内容等关键字']: 'กรุณาใส่เนื้อหาหรือคำสำคัญ',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'ยืนยัน要ลบ[คำพูดส่วนตัว/สาธารณะ][{{title}}]：[{{content}}]ไหม？',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'ไม่มีป้ายเข้าสำหรับเปิดอยู่ จึงไม่สามารถปิดป้ายนี้ได้',
	['没有其他进入标签被开启，故无法删除此标签']: 'ไม่มีแท็กอื่นที่เปิดอยู่ ดังนั้นไม่สามารถลบแท็กนี้ได้',
	['所有人']: 'ทุกคน',
	['自定义对象']: 'วัตถุที่กำหนดเอง',
	['套用对象']: 'วัตถุที่ใช้ร่วม',
	['回主画面']: 'กลับหน้าหลัก',
	['孟加拉语']: 'เบงกาลี',
	['繁体中文']: 'ภาษาจีนตัวเต็ม',
	['简体中文']: 'จีน',
	['韩语']: 'ภาษาเกาหลี',
	['日语']: 'ภาษาญี่ปุ่น',
	['葡萄牙语']: 'ภาษาโปรตุเกส',
	['印地语']: 'ภาษาอินเดีย',
	['俄语']: 'ภาษารัสเซีย',
	['重要资讯']: 'ข้อมูลสำคัญ',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'ในการเปลี่ยนภาษาในการสนทนา อาจทำให้ฟังก์ชันการแปลข้อความล่าช้าประมาณ 10 นาที ส่งผลกระทบต่อการอ่านข้อความใหม่และเก่า คุณแน่ใจหรือว่าต้องการเปลี่ยนภาษา?',
	['暂无对话']: 'ไม่มีการสนทนา',
	['档案上传中']: 'กำลังอัปโหลดไฟล์',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} ได้เปิดการแจ้งเตือนอัตโนมัติเมื่อ {{time}}',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} ได้ปิดการแจ้งเตือนอัตโนมัติเมื่อ {{time}}',
	['商户代码']: 'รหัสผู้ค้า',
	['请输入商户代码']: 'กรุณากรอกรหัสผู้ค้า',
	['密钥']: 'รหัสลับ',
	['请输入密钥']: 'กรุณากรอกรหัสลับ',
	['共同设定']: 'การตั้งค่าทั่วไป',
	['充值未到帐设定']: 'การตั้งค่าการเติมเงินที่ยังไม่เข้าบัญชี',
	['出款未到帐设定']: 'การตั้งค่าการถอนเงินที่ยังไม่เข้าบัญชี',
	['确认进行储存？']: 'ยืนยันการบันทึก?',
	['SKILL开关']: 'สวิตช์ SKILL',
	['请输入SKILL']: 'กรอก SKILL',
	['派单 API 参数']: 'พารามิเตอร์ API การมอบหมายออเดอร์',
	['请输入派单API URL']: 'กรอก URL API การมอบหมายออเดอร์',
	['开单者username']: 'ชื่อผู้ใช้ผู้สร้างออเดอร์',
	['请输入开单者username']: 'กรอกชื่อผู้ใช้ผู้สร้างออเดอร์',
	['频道名称']: 'ชื่อช่อง',
	['请输入频道名称']: 'กรอกชื่อช่อง',
	['开单原因']: 'เหตุผลการสร้างออเดอร์',
	['请输入开单原因']: 'กรอกเหตุผลการสร้างออเดอร์',
	['充值订单查询 API URL']: 'URL API ค้นหาออเดอร์เติมเงิน',
	['出款订单查询 API URL']: 'URL API ค้นหาออเดอร์ถอนเงิน',
	['同义词设定']: 'การตั้งค่าคำพ้อง',
	['开启BM25']: 'เปิด BM25',
	['同义词']: 'คำพ้องความหมาย',
	['更新时间']: 'ปรับปรุงเวลา',
	['批次新增同义词']: 'เพิ่มคำพ้องความหมายเป็นกลุ่ม',
	['修改同义词']: 'แก้ไขคำพ้องความหมาย',
	['新增同义词']: 'เพิ่มคำพ้องความหมาย',
	['请输入同义词，使用逗号区隔不同词汇']: 'กรุณาป้อนคำพ้องความหมาย โดยใช้เครื่องหมายจุลภาคแยกคำต่างๆ',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'กรุณาแยกคำด้วยลูกน้ำ, แยกกลุ่มคำพ้องความหมายด้วยเครื่องหมายเซมิโคลอน',
	['输入格式说明：']: 'รูปแบบการป้อนข้อมูล:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'โปรดใช้, แบ่งแยกคำศัพท์ที่แตกต่างกัน เช่น: เติมเงิน, ฝากเงิน, โอนเงิน, ลงทุน',
	['词汇与标点符号前后不要出现空白']: 'คำศัพท์และเครื่องหมายวรรคตอนต้องไม่มีช่องว่างก่อนหรือหลัง',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'โปรดใช้；หรือแยกบรรทัด(enter)เพื่อแบ่งกลุ่มคำพ้องความหมายเดียวกัน เช่น：',
	['充值,储值,入金,课金']: 'เติมเงิน',
	['log in,登入;亲,宝贝']: 'เข้าสู่ระบบ, เข้าสู่ระบบ; ที่รัก, ลูก宝',
	['请输入同义词']: 'กรุณาใส่คำพ้องความหมาย',
	['同义词不可为空']: 'คำพ้องความหมายไม่สามารถว่างเปล่าได้',
	['同义词格式有误']: 'รูปแบบคำพ้องมีข้อผิดพลาด',
	['同义词不可有特殊字元']: 'คำพ้องความหมายไม่ควรมีอักขระพิเศษ',
	['字元不可超过10000']: 'ตัวอักษรต้องไม่เกิน 10000 ตัว',
	['需至少输入两个词汇']: 'ต้องใส่คำอย่างน้อยสองคำ',
	['删除同义词']: 'ลบคำที่มีความหมายเหมือนกัน',
	['请确认是否删除同义词？']: 'กรุณายืนยันว่าต้องการลบคำพ้องความหมายหรือไม่?',
	['新增同义词成功']: 'เพิ่มคำพ้องความหมายสำเร็จ',
	['新增同义词失败']: 'เพิ่มคำพ้องความหมายล้มเหลว',
	['修改同义词成功']: 'แก้ไขคำพ้องความหมายสำเร็จ',
	['修改同义词失败']: 'การแก้ไขคำพ้องความหมายล้มเหลว',
	['删除同义词成功']: 'ลบคำพ้องความหมายสำเร็จ',
	['删除同义词失败']: 'ลบคำพ้องความหมายล้มเหลว',
	['内容有重复字']: 'เนื้อหามีคำซ้ำ',
	['新增图片，详细图片请参考公告管理']: 'เพิ่มภาพ, โปรดดูการจัดการประกาศสำหรับภาพรายละเอียด',
	['目前只支援ChatGPT进行微调训练']: 'ขณะนี้สนับสนุนเฉพาะการฝึกปรับแต่ง ChatGPT เท่านั้น',
	['AI系列']: 'ซีรีส์ AI',
	['AI系列不能为空']: 'ซีรีส์ AI ห้ามเป็นค่าว่าง',
	['启用ChatGPT']: 'เปิดใช้งาน ChatGPT',
	['启用Gemini']: 'เปิดใช้งาน Gemini',
	['AI客服']: 'AI ผู้ช่วยบริการลูกค้า',
	['ID入口']: 'ID ทางเข้า',
	['IP']: 'IP',
	['USER ID']: 'รหัสผู้ใช้',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}}ห้ามว่างเปล่า',
	['{{text}}仅能输入数字']: '{{text}}สามารถกรอกได้เฉพาะตัวเลข',
	['{{text}}最多{{limit}}个字元']: '{{text}} สูงสุด {{limit}} ตัวอักษร',
	['{{text}}最多數字{{limit}}碼']: '{{text}}มากที่สุด{{limit}}หลัก',
	['{{time}}分']: '{{time}} นาที',
	['{{time}}时']: 'เวลา{{time}}',
	['{{time}}秒']: '{{time}} วินาที',
	['上一则发送后等待时间']: 'รอเวลาหลังจากส่งข้อความก่อนหน้า',
	['上传图片']: 'อัปโหลดภาพ',
	['主要API keys']: 'คีย์ API หลัก',
	['主要语言']: 'ภาษาหลัก',
	['事件']: 'เหตุการณ์',
	['以查看预览效果']: 'เพื่อดูผลลัพธ์ตัวอย่าง',
	['依照选择模组设定UI显示位置及功能。']: 'ตั้งค่าตำแหน่งและฟังก์ชันการแสดงผล UI ตามโมดูลที่เลือก。',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'ปรับสีตามสไตล์ที่เลือก (รวมถึงพื้นหลัง, กรอบ, สี, และเส้นสาย)',
	['修改帐号履历成功']: 'แก้ไขประวัติบัญชีสำเร็จ',
	['修改翻译API成功']: 'แก้ไข API การแปลสำเร็จ',
	['充值帐号']: 'เติมบัญชี',
	['共 {{numOfItems}} 笔']: 'ทั้งหมด {{numOfItems}} รายการ',
	['关 闭']: 'ปิด',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'เมื่อปิด ระบบการส่งข้อความทั้งหมดจะหยุดทำงาน ข้อความส่งทั้งหมดจะไม่สามารถใช้งานได้ชั่วคราว คุณสามารถเปิดใช้งานอีกครั้งได้ทุกเมื่อ',
	['内容最多20字元']: 'เนื้อหาสูงสุด 20 ตัวอักษร',
	['内容预览']: 'เนื้อหาตัวอย่าง',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'หลังจากเปลี่ยนแล้ว ข้อความวิ่งและคีย์ลัดอาจแสดงไม่ชัดเจนหรือความต่างของสีไม่เพียงพอ ต้องไปที่ระบบหลังบ้านเพื่อกำหนดค่าใหม่',
	['删除履历']: 'ลบประวัติ',
	['删除帐号履历成功']: 'ลบประวัติบัญชีสำเร็จ',
	['删除跑马灯']: 'ลบป้ายวิ่ง',
	['加载中...']: 'กำลังโหลด...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'เมื่อเลือกแล้ว บัญชีนี้จะแสดงชื่อบัญชีข้างๆ เมื่อติดต่อฝ่ายบริการลูกค้า',
	['即时预览']: 'ตัวอย่างทันที',
	['取消新增微调文本']: 'ยกเลิกการเพิ่มข้อความการปรับแต่ง',
	['古典深色风格']: 'สไตล์คลาสสิกสีเข้ม',
	['單次']: 'ครั้งเดียว',
	['回传表单']: 'ส่งแบบฟอร์ม',
	['外观风格']: 'รูปแบบภายนอก',
	['客户端视觉设定']: 'การตั้งค่าการมองเห็นของลูกค้า',
	['客户端视觉设定成功']: 'การตั้งค่าทัศนียภาพของลูกค้าสำเร็จ',
	['尚无资料']: 'ยังไม่มีข้อมูล',
	['展开']: 'เปิดเผย',
	['履历数量']: 'จำนวนประวัติการทำงาน',
	['帐号履历']: 'ประวัติบัญชี',
	['帐号履历管理']: 'การจัดการประวัติบัญชี',
	['平台代码不能有空白']: 'รหัสแพลตฟอร์มไม่สามารถมีช่องว่าง',
	['平台代码仅能输入英文和数字']: 'รหัสแพลตฟอร์มสามารถป้อนเฉพาะภาษาอังกฤษและตัวเลขเท่านั้น',
	['平台代码最多5码']: 'รหัสแพลตฟอร์มสูงสุด 5 หลัก',
	['平台代码最少2码']: 'รหัสแพลตฟอร์มอย่างน้อย 2 โค้ด',
	['平台语言']: 'ภาษาแพลตฟอร์ม',
	['平均首次工作时间']: 'เวลาเริ่มทำงานเฉลี่ย',
	['建立者']: 'ผู้ก่อตั้ง',
	['开关']: 'สวิตช์',
	['快速通道']: 'ทางด่วน',
	['手动推播']: 'การส่งข้อความด้วยมือ',
	['手机版']: 'มือถือ',
	['批量删除']: 'ลบเป็นชุด',
	['排序']: 'การจัดเรียง',
	['推播功能']: 'ฟีเจอร์การแจ้งเตือน',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'ฟังก์ชั่นการแจ้งเตือน OFF: ฟังก์ชั่นการแจ้งเตือนปิดระบบทั้งหมดไม่ทำงาน กลยุทธ์ทั้งหมดในรายการจะไม่มีผล.',
	['推播时间']: 'เวลาการส่งข้อมูล',
	['推播讯息列表']: 'รายการข้อความแจ้งเตือน',
	['推播设定']: 'การตั้งค่าการแจ้งเตือน',
	['操作内容']: 'การดำเนินงาน',
	['收起']: 'เก็บกลับ',
	['数值/内容']: 'ค่าตัวเลข/เนื้อหา',
	['数值/内容不可为空']: 'ค่า/เนื้อหาต้องไม่ว่างเปล่า',
	['数值只能输入数字、负号、小数点']: 'ค่าตัวเลขสามารถป้อนเป็นตัวเลข เครื่องหมายลบ และจุดทศนิยมเท่านั้น',
	['数值小数最多6位数']: 'ค่าทศนิยมสูงสุด 6 หลัก',
	['数值整数最多15位']: 'จำนวนเต็มสูงสุด 15 หลัก',
	['新增履历']: 'เพิ่มประวัติประจำตัว',
	['新增帐号履历成功']: 'เพิ่มประวัติบัญชีสำเร็จ',
	['新增类型']: 'เพิ่มประเภท',
	['无工作']: 'ไม่มีงาน',
	['时间设定需至少为 3 分钟']: 'การตั้งเวลาอย่างน้อยต้องเป็น 3 นาที',
	['是否修改翻译API?']: 'คุณต้องการปรับปรุง API การแปลใช่ไหม?',
	['更新成功']: 'อัปเดตสำเร็จ',
	['更新者']: 'ผู้ปรับปรุง',
	['架构模组']: 'โมดูลสถาปัตยกรรม',
	['栏位名称']: 'ชื่อคอลัมน์',
	['栏位类型']: 'ประเภทคอลัมน์',
	['栏位类型不可为空']: 'ประเภทคอลัมน์ไม่สามารถว่างเปล่าได้',
	['档案格式不符']: 'รูปแบบไฟล์ไม่ถูกต้อง',
	['PDF文件']: 'เอกสาร PDF',
	['模式与间隔时间']: 'รูปแบบและระยะเวลา',
	['欢迎回来']: 'ยินดีต้อนรับกลับมา',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'การดำเนินการนี้จะทำการแปลภาษาอื่นโดยอัตโนมัติ ข้อมูลที่ป้อนก่อนหน้านี้จะถูกแทนที่ด้วยผลลัพธ์การแปล กรุณายืนยันว่าต้องการดำเนินการต่อหรือไม่?',
	['汇入']: 'นำเข้า',
	['汇入微调文本成功']: 'นำเข้าข้อความการปรับแต่งสำเร็จ',
	['汇出微调文本成功']: 'ส่งออกข้อความการปรับปรุงสำเร็จ',
	['清空翻译']: 'ล้างการแปล',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'ต้องกรอกเนื้อหาของทุกภาษาให้ครบก่อนจึงจะยืนยันได้ สามารถใช้การแปลอัตโนมัติเพื่อเติมภาษาที่เหลือ',
	['标题与内容皆需填写才可自动翻译']: 'ต้องกรอกทั้งหัวข้อและเนื้อหาก่อนจึงจะแปลอัตโนมัติได้',
	['状态持续时间']: 'ระยะเวลาสถานะ',
	['用户帐号']: 'บัญชีผู้ใช้',
	['用户帐号不能为空']: 'บัญชีผู้ใช้ไม่สามารถว่างเปล่าได้',
	['电脑版']: 'ระบบเดสก์ท็อป',
	['目前无适用推播']: 'ขณะนี้ไม่มีการแจ้งเตือนที่ใช้ได้',
	['目前有启用中的侦测语言平台，无法关闭']: 'ขณะนี้มีแพลตฟอร์มการตรวจจับภาษาแบบเปิดใช้งานอยู่ ไม่สามารถปิดได้',
	['确定删除IP白名单？']: 'ยืนยันที่จะลบรายชื่อ IP ที่อนุญาตหรือไม่?',
	['确定发送推播？']: 'ยืนยันส่งการแจ้งเตือนไหม？',
	['确定要关闭推播功能吗？']: 'คุณต้องการปิดการแจ้งเตือนหรือไม่?',
	['确认删除此笔履历?']: 'ยืนยันการลบประวัตินี้ไหม?',
	['确认要删除推播讯息？']: 'ยืนยันที่จะลบข้อความส่งเสริมการขายหรือไม่?',
	['立即登入']: 'เข้าสู่ระบบทันที',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'จาก {{min}} - {{max}} รายการ/ทั้งหมด {{numOfItems}} รายการ',
	['筛选条件']: 'เงื่อนไขการคัดกรอง',
	['类型名称']: 'ประเภทชื่อ',
	['系统预设模组']: 'ระบบตั้งค่ามาตรฐาน',
	['经典浅色风格']: 'สไตล์สีอ่อนคลาสสิก',
	['翻译API']: 'แปล API',
	['聊天介面']: 'อินเตอร์เฟซการแชท',
	['自动推播']: 'การแจ้งเตือนอัตโนมัติ',
	['自动推播功能']: 'ฟังก์ชันการส่งข้อความอัตโนมัติ',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'ฟังก์ชันการส่งข้อความอัตโนมัติ ปิด: ข้อความส่งทั้งหมดในรายการยังคงสามารถดำเนินการโดยฝ่ายบริการลูกค้าได้ด้วยตนเอง แต่ฟังก์ชันตัวจับเวลาทั้งหมดจะหยุดทำงาน。',
	['自定义']: 'กำหนดเอง',
	['自定义文案']: 'ข้อความที่กำหนดเอง',
	['自客服接起对话后开始计算']: 'เมื่อลูกค้าติดต่อฝ่ายบริการลูกค้าแล้ว เริ่มคำนวณ',
	['该类型目前有推播讯息套用中，无法删除']: 'ประเภทนี้ขณะนี้มีการใช้ข้อความแจ้งเตือนอยู่ ไม่สามารถลบได้',
	['详细说明']: 'รายละเอียด',
	['请先选择推播类型']: 'กรุณาเลือกประเภทการแจ้งเตือนก่อน',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'กรุณายืนยันว่าต้องการลบรายการหลายรายการ (ทั้งหมด {{selectedFineTuningRecordsLength}} รายการ) หรือไม่?',
	['请输入事件']: 'กรุณาป้อนเหตุการณ์',
	['请输入会员ID']: 'โปรดป้อนรหัสสมาชิก',
	['请输入內容']: 'กรุณาใส่เนื้อหา',
	['请输入关键字']: 'กรุณาใส่คีย์เวิร์ด',
	['请输入您的会员 ID 以继续']: 'กรุณาใส่รหัสสมาชิกของคุณเพื่อดำเนินการต่อ',
	['请输入数值/内容']: 'กรุณาป้อนจำนวน/เนื้อหา',
	['请输入文字']: 'กรุณาใส่ข้อความ',
	['请输入栏位名称']: 'กรุณาใส่ชื่อช่อง',
	['请输入用户帐号']: 'กรุณาใส่บัญชีผู้ใช้',
	['请输入类型名称']: 'กรุณาใส่ชื่อประเภท',
	['请输入详细说明']: 'โปรดใส่รายละเอียดที่ชัดเจน',
	['请选择上方下拉选单']: 'โปรดเลือกจากเมนูแบบเลื่อนด้านบน',
	['请选择主要语言自动翻译']: 'กรุณาเลือกภาษาหลักเพื่อแปลอัตโนมัติ',
	['请选择帐号状态']: 'กรุณาเลือกสถานะบัญชี',
	['请选择平台']: 'กรุณาเลือกแพลตฟอร์ม',
	['请选择推播项目']: 'กรุณาเลือกลักษณะการแจ้งเตือน',
	['请选择栏位类型']: 'กรุณาเลือกประเภทคอลัมน์',
	['请选择类型']: 'โปรดเลือกรูปแบบ',
	['请选择类型与项目(标题)以预览内容']: 'โปรดเลือกประเภทและโครงการ (หัวข้อ) เพื่อดูตัวอย่างเนื้อหา',
	['请选择表单选项']: 'กรุณาเลือกตัวเลือกแบบฟอร์ม',
	['请选择运算规则']: 'กรุณาเลือกกฎการคำนวณ',
	['请选择预览画面']: 'กรุณาเลือกหน้าตัวอย่าง',
	['跑马灯设定']: 'การตั้งค่าแฟลชวิ่ง',
	['轮播']: 'สไลด์โชว์',
	['轮播模式']: 'โหมดเลื่อนภาพ',
	['轮播间隔时间']: 'ระยะเวลาในการเลื่อนภาพ',
	['运算规则']: 'กฎการคำนวณ',
	['运算规则不可为空']: 'กฎการคำนวณไม่สามารถว่างเปล่าได้',
	['返回上一层']: 'กลับไปยังชั้นก่อนหน้า',
	['返回上一页']: 'กลับไปหน้าก่อน',
	['送出推播']: 'ส่งการแจ้งเตือน',
	['选单介面']: 'เมนูอินเตอร์เฟส',
	['选择推播类型']: 'เลือกประเภทการส่งข้อความ',
	['选择推播项目(标题)']: 'เลือกหัวข้อการแจ้งเตือน',
	['通知时间']: 'เวลาแจ้งเตือน',
	['通知时间不能为空']: 'เวลาการแจ้งเตือนห้ามว่าง',
	['重新产生Key/IV']: 'สร้าง Key/IV ใหม่',
	['重要客户']: 'ลูกค้าสำคัญ',
	['需为1~60正整数']: 'ต้องเป็นจำนวนเต็มบวก 1~60',
	['预估时间']: 'เวลาที่คาดการณ์',
	['预览图片']: 'ดูตัวอย่างภาพ',
	['首次工作时间报表']: 'รายงานเวลาในการทำงานครั้งแรก',
	['日志管理']: 'การจัดการล็อก',
	['API传送日志']: 'ล็อกการส่ง API',
	['订单号']: 'หมายเลขคำสั่งซื้อ',
	['三方单号']: 'หมายเลขคำสั่งซื้อบุคคลที่สาม',
	['请输入订单号']: 'กรุณาใส่หมายเลขคำสั่งซื้อ',
	['请输入三方单号']: 'กรุณาใส่หมายเลขคำสั่งซื้อบุคคลที่สาม',
	['充值订单查询']: 'ค้นหาคำสั่งเติมเงิน',
	['出款订单查询']: 'ค้นหาคำสั่งถอนเงิน',
	['开派单']: 'สร้างใบจัดส่ง',
	['传送派单信息']: 'ส่งข้อมูลใบจัดส่ง',
	['CS传送资料']: 'ข้อมูลที่ CS ส่ง',
	['平台回覆资料']: 'ข้อมูลตอบกลับจากแพลตฟอร์ม',
	['{{text}}需以{{prefix}}开头']: '{{-text}} ต้องขึ้นต้นด้วย {{-prefix}}',
	['系统通知']: 'การแจ้งเตือนระบบ',
	['派单传送讯息']: 'ส่งข้อความใบจัดส่ง',
	['派单传送档案']: 'ส่งไฟล์ใบจัดส่ง',
	['请输入平台']: 'กรุณากรอกแพลตฟอร์ม',
	['派单讯息润饰设定']: 'ตั้งค่าการขัดเกลาข้อความใบจัดส่ง',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'คำสั่งนี้จะไม่โหลด "ตั้งค่า AI ร่วม" และ "ตั้งค่า AI แพลตฟอร์ม" ใช้เป็น Agent อิสระ',
	['用户个人设定']: 'การตั้งค่าส่วนตัวของผู้ใช้',
	['新增用户个人资讯']: 'เพิ่มข้อมูลส่วนตัวของผู้ใช้',
	['个人资讯参数名称']: 'ชื่อพารามิเตอร์ข้อมูลส่วนตัว',
	['请输入个人资讯参数名称']: 'กรุณากรอกชื่อพารามิเตอร์ข้อมูลส่วนตัว',
	['*新增多个请使用逗号「 , 」隔开']: '*หากเพิ่มหลายรายการ กรุณาคั่นด้วยเครื่องหมายจุลภาค「 , 」',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'ใช้สำหรับตั้งค่าว่าข้อมูลส่วนตัวใดของแพลตฟอร์มนี้จะส่งให้ AI เฉพาะพารามิเตอร์ที่ตั้งค่าไว้ใน "การตั้งค่าส่วนตัวของผู้ใช้" เท่านั้นที่จะส่งให้ AI',
	['批次删除用户个人资讯']: 'ลบข้อมูลส่วนตัวของผู้ใช้เป็นกลุ่ม',
	['确定要批次删除用户个人资讯吗？']: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลส่วนตัวของผู้ใช้เป็นกลุ่ม?',
	['个人资讯参数名称不能为空']: 'ชื่อพารามิเตอร์ข้อมูลส่วนตัวต้องไม่ว่างเปล่า',
	['已存在「{{name}}」']: 'มี「{{-name}}」อยู่แล้ว',
	['最多可新增{{limit}}个，已超过上限']: 'สามารถเพิ่มได้สูงสุด {{-limit}} รายการ เกินขีดจำกัดแล้ว',
	['新增用户个人资讯成功']: 'เพิ่มข้อมูลส่วนตัวของผู้ใช้สำเร็จ',
	['新增用户个人资讯失败']: 'เพิ่มข้อมูลส่วนตัวของผู้ใช้ไม่สำเร็จ',
	['删除用户个人资讯成功']: 'ลบข้อมูลส่วนตัวของผู้ใช้สำเร็จ',
	['删除用户个人资讯失败']: 'ลบข้อมูลส่วนตัวของผู้ใช้ไม่สำเร็จ',
	['图像管理']: 'การจัดการรูปภาพ',
	['自定义图像']: 'รูปภาพที่กำหนดเอง',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'รูปแบบไฟล์: "PNG, JPG" ขนาดไฟล์ต้องไม่เกิน 500KB',
	['档案最大500K']: 'ไฟล์สูงสุด 500K',
	['新增图像成功']: 'เพิ่มรูปภาพสำเร็จ',
	['删除图像成功']: 'ลบรูปภาพสำเร็จ',
	['是否确定删除图像？']: 'คุณแน่ใจหรือไม่ว่าต้องการลบรูปภาพนี้?',
	['内容设定']: 'ตั้งค่าเนื้อหา',
	['英语']: 'ภาษาอังกฤษ',
	['{{language}}内容']: 'เนื้อหา{{language}}',
	['请输入{{language}}内容']: 'กรุณาใส่เนื้อหา{{language}}',
	['请选择时间']: 'กรุณาเลือกเวลา',
	['请选择公司']: 'กรุณาเลือกบริษัท',
	['请输入{{label}}']: 'กรุณาใส่{{label}}',
	['原文参考（{{language}}）']: 'อ้างอิงต้นฉบับ ({{language}})',
	['确定清空设定吗？']: 'คุณแน่ใจหรือไม่ว่าต้องการล้างการตั้งค่า?',
	['确定取消设定吗？']: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการตั้งค่า?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'ยังไม่เสร็จสมบูรณ์',
	['{{language}}{{label}}超过{{limit}}字']: '{{label}}ของ {{language}} เกิน {{limit}} ตัวอักษร',
	['公告标题']: 'หัวข้อประกาศ',
	['进线IP']: 'IP ที่เชื่อมต่อ',
	['请输入进线IP']: 'กรุณากรอก IP ที่เชื่อมต่อ',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'สลับโมเดล: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'หลังจากลบบัญชีในระบบหลังบ้าน BW แล้ว บัญชีระบบบริการลูกค้าจะถูกลบพร้อมกัน',
	['系统已有新版本，请重新整理']: 'มีเวอร์ชันใหม่แล้ว โปรดอัปเดต',
	['页面加载失败，请重试']: 'โหลดหน้าไม่สำเร็จ โปรดลองอีกครั้ง',
	['翻译中']: 'กำลังแปล',
	['监控与即时摘要设定']: 'ตั้งค่าการติดตามและสรุปทันที',
	['批量转接']: 'โอนย้ายเป็นกลุ่ม',
	['已选 {{count}} 则对话']: 'เลือกแล้ว {{count}} บทสนทนา',
	['勾选']: 'เลือก',
	['全平台服务人数']: 'ปริมาณในการให้บริการทุกแพลตฟอร์ม',
	['未开启{{platform}}平台']: 'ยังไม่ได้เปิดแพลตฟอร์ม {{-platform}}',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: 'ถ่ายโอนจาก {{-inviter}} ไปยัง {{-invitee}} สำเร็จ รวม {{count}} รายการ',
	['接受']: 'ยอมรับ',
	['拒绝({{seconds}}S)']: 'ปฏิเสธ({{seconds}}S)',
	['生成链接']: 'สร้างลิงก์',
	['链接生成中...']: 'กำลังสร้างลิงก์...',
	['复制链接']: 'คัดลอกลิงก์',
	['已复制链接']: 'คัดลอกลิงก์แล้ว',
	['档案上传失败']: 'อัปโหลดไฟล์ล้มเหลว',
	['转档失败，请重新上传']: 'แปลงไฟล์ล้มเหลว กรุณาอัปโหลดใหม่อีกครั้ง',
	['人工回复']: 'ตอบกลับด้วยตนเอง',
	['检视回复']: 'ดูการตอบกลับ',
	['{{time}} AI 拦截对话']: '{{time}} AI สกัดกั้นการสนทนา',
	['AI 拦截原因与人工回复']: 'เหตุผลที่ AI สกัดกั้นและการตอบกลับด้วยตนเอง',
	['人工回复失败']: 'ตอบกลับด้วยตนเองไม่สำเร็จ',
	['回复讯息']: 'ข้อความตอบกลับ',
	['对话摘要']: 'สรุปการสนทนา',
	['建议回复']: 'การตอบกลับที่แนะนำ',
	['拦截原因']: 'เหตุผลที่สกัดกั้น',
	['拦截回复']: 'การตอบกลับที่ถูกสกัดกั้น',
	['确定送出']: 'ยืนยันการส่ง',
	['生成链接失败']: 'สร้างลิงก์ไม่สำเร็จ',
	['连接超时，请稍后再试']: 'การเชื่อมต่อหมดเวลา กรุณาลองใหม่อีกครั้งในภายหลัง',
	['上一则']: 'ก่อนหน้า',
	['下一则']: 'ถัดไป',
	['重新传送']: 'ส่งอีกครั้ง',
	['传送中...']: 'กำลังส่ง...',
	['用户端翻译失败']: 'แปลไปยังฝั่งผู้ใช้ล้มเหลว',
	['重新传送失败']: 'ส่งซ้ำไม่สำเร็จ',
	['请确认是否删除以下模型？']: 'ยืนยันการลบโมเดลต่อไปนี้หรือไม่?',
	['新增模型']: 'เพิ่มโมเดล',
	['请选择AI系列']: 'กรุณาเลือกซีรีส์ AI',
	['支援模型']: 'โมเดลที่รองรับ',
	['支援模型不能为空']: 'โมเดลที่รองรับต้องไม่เว้นว่าง',
	['请选择支援模型']: 'กรุณาเลือกโมเดลที่รองรับ',
	['AI模型管理']: 'การจัดการโมเดล AI',
	['模型不能为空']: 'โมเดลต้องไม่เว้นว่าง',
	['请选择模型']: 'กรุณาเลือกโมเดล',

	['对话类型']: 'ประเภทการสนทนา',
	['单纯AI讯息']: 'ข้อความ AI เท่านั้น',
	['单纯人员讯息']: 'ข้อความพนักงานเท่านั้น',
	['人员+AI讯息']: 'ข้อความพนักงาน + AI',
	['是否经过AI拦截']: 'ผ่านการสกัดกั้นของ AI หรือไม่',
	['是否修改AI拦截建议回覆']: 'แก้ไขข้อความตอบกลับที่ AI แนะนำหรือไม่',
	['监控API keys']: 'คีย์ API สำหรับการตรวจสอบ',
	['管理']: 'จัดการ',

	['启用显性快取']: 'เปิดใช้แคชแบบชัดแจ้ง',
	['AI监控拦截总量']: 'จำนวนการสกัดกั้นโดย AI ทั้งหมด',
	['AI监控拦截']: 'การสกัดกั้นโดย AI',
	['有修改建议回覆总量']: 'ที่แก้ไขการตอบกลับที่แนะนำ',
	['触发关键字：{{keywords}}。']: 'คำหลักที่ถูกกระตุ้น: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: 'ใช้เลย์เอาต์แล้ว แต่ยังไม่ได้ซิงค์กับบัญชี',
	['服务器重设失败，下次开启工作区时会再同步']: 'รีเซ็ตบนเซิร์ฟเวอร์ไม่สำเร็จ ระบบจะซิงค์อีกครั้งเมื่อเปิดพื้นที่ทำงานครั้งถัดไป',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'เบราว์เซอร์ไม่สามารถบันทึกเลย์เอาต์ได้ โปรดตรวจสอบว่าซิงค์กับบัญชีเรียบร้อยก่อนออก',

	['重设版面配置']: 'รีเซ็ตเลย์เอาต์',
	['确定要将版面配置回复为系统预设吗？']: 'ต้องการคืนค่าเลย์เอาต์เป็นค่าเริ่มต้นของระบบหรือไม่?',
	['客服支援语言']: 'ภาษาที่ฝ่ายบริการลูกค้ารองรับ',
	['请选择支援语言']: 'กรุณาเลือกภาษาที่รองรับ',
	['请选择客服支援语言']: 'กรุณาเลือกภาษาที่ฝ่ายบริการลูกค้ารองรับ',

	['删除平台']: 'ลบแพลตฟอร์ม',
	['是否确定删除{{code}}平台']: 'คุณแน่ใจหรือไม่ว่าต้องการลบแพลตฟอร์ม {{-code}}?',
	['删除{{code}}平台成功']: 'ลบแพลตฟอร์ม {{-code}} สำเร็จ',
	['上传图片或PDF']: 'อัปโหลดภาพหรือ PDF',
	['当前平台维护中，如有疑问请联系管理员']: 'แพลตฟอร์มปัจจุบันอยู่ระหว่างการปิดปรับปรุง หากมีข้อสงสัยกรุณาติดต่อผู้ดูแลระบบ',
	['当前平台已禁用，如有疑问请联系管理员']: 'แพลตฟอร์มปัจจุบันถูกปิดใช้งาน หากมีข้อสงสัยกรุณาติดต่อผู้ดูแลระบบ',
	['收回提示文字']: 'ข้อความแจ้งเมื่อเรียกคืน',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'โปรดป้อนข้อความแจ้ง เช่น: ขออภัยที่รัก ฉันส่งข้อความผิด โปรดแก้ไขให้ถูกต้อง!',
	['标签名称']: 'ชื่อฉลาก',
	['预览失败']: 'ดูตัวอย่างไม่สำเร็จ',
	['放大']: 'ขยาย',
	['缩小']: 'ย่อ',
	['上一页']: 'หน้าก่อนหน้า',
	['下一页']: 'หน้าถัดไป',
	['点击预览']: 'คลิกเพื่อดูตัวอย่าง',
};
